var La = Object.defineProperty;
var Fa = (t, e, r) => e in t ? La(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r;
var $ = (t, e, r) => Fa(t, typeof e != "symbol" ? e + "" : e, r);
import x, { Component as Va, createElement as Ua, useEffect as oo, useRef as ao, useMemo as so } from "react";
const Ba = (t) => () => {
  console.warn(`${t} need to be implement getComponent`);
}, Ga = ["customPageRootRender"], Hr = [
  // 页面渲染
  "pageRender",
  // 渲染一个组件
  "render",
  // 将一个 组件 model 节点 转换为一个可被运行的渲染函数
  "convertModelToComponent",
  "getComponent",
  "getContext",
  "getUtils",
  "transformProps",
  "errorCatch",
  "requestAPI",
  "clear"
], za = (t) => [...Hr, ...Ga].reduce((r, n) => {
  var o;
  return t != null && t[n] ? r[n] = (o = t[n]) == null ? void 0 : o.bind(t) : Hr.includes(n) && (r[n] = Ba), r;
}, {});
var io = typeof global == "object" && global && global.Object === Object && global, ka = typeof self == "object" && self && self.Object === Object && self, X = io || ka || Function("return this")(), lt = X.Symbol, co = Object.prototype, Ha = co.hasOwnProperty, Ja = co.toString, kt = lt ? lt.toStringTag : void 0;
function Wa(t) {
  var e = Ha.call(t, kt), r = t[kt];
  try {
    t[kt] = void 0;
    var n = !0;
  } catch {
  }
  var o = Ja.call(t);
  return n && (e ? t[kt] = r : delete t[kt]), o;
}
var qa = Object.prototype, Ka = qa.toString;
function Qa(t) {
  return Ka.call(t);
}
var Ya = "[object Null]", Xa = "[object Undefined]", Jr = lt ? lt.toStringTag : void 0;
function Ot(t) {
  return t == null ? t === void 0 ? Xa : Ya : Jr && Jr in Object(t) ? Wa(t) : Qa(t);
}
function ft(t) {
  return t != null && typeof t == "object";
}
var Za = "[object Symbol]";
function ts(t) {
  return typeof t == "symbol" || ft(t) && Ot(t) == Za;
}
function es(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, o = Array(n); ++r < n; )
    o[r] = e(t[r], r, t);
  return o;
}
var ot = Array.isArray, Wr = lt ? lt.prototype : void 0, qr = Wr ? Wr.toString : void 0;
function uo(t) {
  if (typeof t == "string")
    return t;
  if (ot(t))
    return es(t, uo) + "";
  if (ts(t))
    return qr ? qr.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
function Et(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
function lo(t) {
  return t;
}
var rs = "[object AsyncFunction]", ns = "[object Function]", os = "[object GeneratorFunction]", as = "[object Proxy]";
function dr(t) {
  if (!Et(t))
    return !1;
  var e = Ot(t);
  return e == ns || e == os || e == rs || e == as;
}
var Me = X["__core-js_shared__"], Kr = function() {
  var t = /[^.]+$/.exec(Me && Me.keys && Me.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function ss(t) {
  return !!Kr && Kr in t;
}
var is = Function.prototype, cs = is.toString;
function $t(t) {
  if (t != null) {
    try {
      return cs.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var us = /[\\^$.*+?()[\]{}|]/g, ls = /^\[object .+?Constructor\]$/, fs = Function.prototype, ds = Object.prototype, ps = fs.toString, hs = ds.hasOwnProperty, gs = RegExp(
  "^" + ps.call(hs).replace(us, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function vs(t) {
  if (!Et(t) || ss(t))
    return !1;
  var e = dr(t) ? gs : ls;
  return e.test($t(t));
}
function ms(t, e) {
  return t == null ? void 0 : t[e];
}
function wt(t, e) {
  var r = ms(t, e);
  return vs(r) ? r : void 0;
}
var ze = wt(X, "WeakMap"), Qr = Object.create, ys = /* @__PURE__ */ function() {
  function t() {
  }
  return function(e) {
    if (!Et(e))
      return {};
    if (Qr)
      return Qr(e);
    t.prototype = e;
    var r = new t();
    return t.prototype = void 0, r;
  };
}();
function bs(t, e, r) {
  switch (r.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, r[0]);
    case 2:
      return t.call(e, r[0], r[1]);
    case 3:
      return t.call(e, r[0], r[1], r[2]);
  }
  return t.apply(e, r);
}
function _s(t, e) {
  var r = -1, n = t.length;
  for (e || (e = Array(n)); ++r < n; )
    e[r] = t[r];
  return e;
}
var Ss = 800, Os = 16, Es = Date.now;
function $s(t) {
  var e = 0, r = 0;
  return function() {
    var n = Es(), o = Os - (n - r);
    if (r = n, o > 0) {
      if (++e >= Ss)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
function ws(t) {
  return function() {
    return t;
  };
}
var he = function() {
  try {
    var t = wt(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), Cs = he ? function(t, e) {
  return he(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: ws(e),
    writable: !0
  });
} : lo, Ns = $s(Cs), js = 9007199254740991, xs = /^(?:0|[1-9]\d*)$/;
function fo(t, e) {
  var r = typeof t;
  return e = e ?? js, !!e && (r == "number" || r != "symbol" && xs.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
function pr(t, e, r) {
  e == "__proto__" && he ? he(t, e, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : t[e] = r;
}
function ae(t, e) {
  return t === e || t !== t && e !== e;
}
var As = Object.prototype, Ts = As.hasOwnProperty;
function Rs(t, e, r) {
  var n = t[e];
  (!(Ts.call(t, e) && ae(n, r)) || r === void 0 && !(e in t)) && pr(t, e, r);
}
function Ms(t, e, r, n) {
  var o = !r;
  r || (r = {});
  for (var a = -1, s = e.length; ++a < s; ) {
    var i = e[a], c = void 0;
    c === void 0 && (c = t[i]), o ? pr(r, i, c) : Rs(r, i, c);
  }
  return r;
}
var Yr = Math.max;
function Ps(t, e, r) {
  return e = Yr(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var n = arguments, o = -1, a = Yr(n.length - e, 0), s = Array(a); ++o < a; )
      s[o] = n[e + o];
    o = -1;
    for (var i = Array(e + 1); ++o < e; )
      i[o] = n[o];
    return i[e] = r(s), bs(t, this, i);
  };
}
function Is(t, e) {
  return Ns(Ps(t, e, lo), t + "");
}
var Ds = 9007199254740991;
function po(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= Ds;
}
function Oe(t) {
  return t != null && po(t.length) && !dr(t);
}
function Ls(t, e, r) {
  if (!Et(r))
    return !1;
  var n = typeof e;
  return (n == "number" ? Oe(r) && fo(e, r.length) : n == "string" && e in r) ? ae(r[e], t) : !1;
}
function Fs(t) {
  return Is(function(e, r) {
    var n = -1, o = r.length, a = o > 1 ? r[o - 1] : void 0, s = o > 2 ? r[2] : void 0;
    for (a = t.length > 3 && typeof a == "function" ? (o--, a) : void 0, s && Ls(r[0], r[1], s) && (a = o < 3 ? void 0 : a, o = 1), e = Object(e); ++n < o; ) {
      var i = r[n];
      i && t(e, i, n, a);
    }
    return e;
  });
}
var Vs = Object.prototype;
function hr(t) {
  var e = t && t.constructor, r = typeof e == "function" && e.prototype || Vs;
  return t === r;
}
function Us(t, e) {
  for (var r = -1, n = Array(t); ++r < t; )
    n[r] = e(r);
  return n;
}
var Bs = "[object Arguments]";
function Xr(t) {
  return ft(t) && Ot(t) == Bs;
}
var ho = Object.prototype, Gs = ho.hasOwnProperty, zs = ho.propertyIsEnumerable, ke = Xr(/* @__PURE__ */ function() {
  return arguments;
}()) ? Xr : function(t) {
  return ft(t) && Gs.call(t, "callee") && !zs.call(t, "callee");
};
function ks() {
  return !1;
}
var go = typeof exports == "object" && exports && !exports.nodeType && exports, Zr = go && typeof module == "object" && module && !module.nodeType && module, Hs = Zr && Zr.exports === go, tn = Hs ? X.Buffer : void 0, Js = tn ? tn.isBuffer : void 0, ge = Js || ks, Ws = "[object Arguments]", qs = "[object Array]", Ks = "[object Boolean]", Qs = "[object Date]", Ys = "[object Error]", Xs = "[object Function]", Zs = "[object Map]", ti = "[object Number]", ei = "[object Object]", ri = "[object RegExp]", ni = "[object Set]", oi = "[object String]", ai = "[object WeakMap]", si = "[object ArrayBuffer]", ii = "[object DataView]", ci = "[object Float32Array]", ui = "[object Float64Array]", li = "[object Int8Array]", fi = "[object Int16Array]", di = "[object Int32Array]", pi = "[object Uint8Array]", hi = "[object Uint8ClampedArray]", gi = "[object Uint16Array]", vi = "[object Uint32Array]", M = {};
M[ci] = M[ui] = M[li] = M[fi] = M[di] = M[pi] = M[hi] = M[gi] = M[vi] = !0;
M[Ws] = M[qs] = M[si] = M[Ks] = M[ii] = M[Qs] = M[Ys] = M[Xs] = M[Zs] = M[ti] = M[ei] = M[ri] = M[ni] = M[oi] = M[ai] = !1;
function mi(t) {
  return ft(t) && po(t.length) && !!M[Ot(t)];
}
function yi(t) {
  return function(e) {
    return t(e);
  };
}
var vo = typeof exports == "object" && exports && !exports.nodeType && exports, Jt = vo && typeof module == "object" && module && !module.nodeType && module, bi = Jt && Jt.exports === vo, Pe = bi && io.process, en = function() {
  try {
    var t = Jt && Jt.require && Jt.require("util").types;
    return t || Pe && Pe.binding && Pe.binding("util");
  } catch {
  }
}(), rn = en && en.isTypedArray, gr = rn ? yi(rn) : mi, _i = Object.prototype, Si = _i.hasOwnProperty;
function mo(t, e) {
  var r = ot(t), n = !r && ke(t), o = !r && !n && ge(t), a = !r && !n && !o && gr(t), s = r || n || o || a, i = s ? Us(t.length, String) : [], c = i.length;
  for (var u in t)
    (e || Si.call(t, u)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    fo(u, c))) && i.push(u);
  return i;
}
function yo(t, e) {
  return function(r) {
    return t(e(r));
  };
}
var Oi = yo(Object.keys, Object), Ei = Object.prototype, $i = Ei.hasOwnProperty;
function wi(t) {
  if (!hr(t))
    return Oi(t);
  var e = [];
  for (var r in Object(t))
    $i.call(t, r) && r != "constructor" && e.push(r);
  return e;
}
function Ci(t) {
  return Oe(t) ? mo(t) : wi(t);
}
function Ni(t) {
  var e = [];
  if (t != null)
    for (var r in Object(t))
      e.push(r);
  return e;
}
var ji = Object.prototype, xi = ji.hasOwnProperty;
function Ai(t) {
  if (!Et(t))
    return Ni(t);
  var e = hr(t), r = [];
  for (var n in t)
    n == "constructor" && (e || !xi.call(t, n)) || r.push(n);
  return r;
}
function bo(t) {
  return Oe(t) ? mo(t, !0) : Ai(t);
}
var Qt = wt(Object, "create");
function Ti() {
  this.__data__ = Qt ? Qt(null) : {}, this.size = 0;
}
function Ri(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var Mi = "__lodash_hash_undefined__", Pi = Object.prototype, Ii = Pi.hasOwnProperty;
function Di(t) {
  var e = this.__data__;
  if (Qt) {
    var r = e[t];
    return r === Mi ? void 0 : r;
  }
  return Ii.call(e, t) ? e[t] : void 0;
}
var Li = Object.prototype, Fi = Li.hasOwnProperty;
function Vi(t) {
  var e = this.__data__;
  return Qt ? e[t] !== void 0 : Fi.call(e, t);
}
var Ui = "__lodash_hash_undefined__";
function Bi(t, e) {
  var r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = Qt && e === void 0 ? Ui : e, this;
}
function bt(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
bt.prototype.clear = Ti;
bt.prototype.delete = Ri;
bt.prototype.get = Di;
bt.prototype.has = Vi;
bt.prototype.set = Bi;
function Gi() {
  this.__data__ = [], this.size = 0;
}
function Ee(t, e) {
  for (var r = t.length; r--; )
    if (ae(t[r][0], e))
      return r;
  return -1;
}
var zi = Array.prototype, ki = zi.splice;
function Hi(t) {
  var e = this.__data__, r = Ee(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : ki.call(e, r, 1), --this.size, !0;
}
function Ji(t) {
  var e = this.__data__, r = Ee(e, t);
  return r < 0 ? void 0 : e[r][1];
}
function Wi(t) {
  return Ee(this.__data__, t) > -1;
}
function qi(t, e) {
  var r = this.__data__, n = Ee(r, t);
  return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
}
function at(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
at.prototype.clear = Gi;
at.prototype.delete = Hi;
at.prototype.get = Ji;
at.prototype.has = Wi;
at.prototype.set = qi;
var Yt = wt(X, "Map");
function Ki() {
  this.size = 0, this.__data__ = {
    hash: new bt(),
    map: new (Yt || at)(),
    string: new bt()
  };
}
function Qi(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function $e(t, e) {
  var r = t.__data__;
  return Qi(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
function Yi(t) {
  var e = $e(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function Xi(t) {
  return $e(this, t).get(t);
}
function Zi(t) {
  return $e(this, t).has(t);
}
function tc(t, e) {
  var r = $e(this, t), n = r.size;
  return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
}
function Ct(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
Ct.prototype.clear = Ki;
Ct.prototype.delete = Yi;
Ct.prototype.get = Xi;
Ct.prototype.has = Zi;
Ct.prototype.set = tc;
function _o(t) {
  return t == null ? "" : uo(t);
}
function ec(t, e) {
  for (var r = -1, n = e.length, o = t.length; ++r < n; )
    t[o + r] = e[r];
  return t;
}
var So = yo(Object.getPrototypeOf, Object), rc = "[object Object]", nc = Function.prototype, oc = Object.prototype, Oo = nc.toString, ac = oc.hasOwnProperty, sc = Oo.call(Object);
function Ft(t) {
  if (!ft(t) || Ot(t) != rc)
    return !1;
  var e = So(t);
  if (e === null)
    return !0;
  var r = ac.call(e, "constructor") && e.constructor;
  return typeof r == "function" && r instanceof r && Oo.call(r) == sc;
}
function ic(t, e, r) {
  var n = -1, o = t.length;
  e < 0 && (e = -e > o ? 0 : o + e), r = r > o ? o : r, r < 0 && (r += o), o = e > r ? 0 : r - e >>> 0, e >>>= 0;
  for (var a = Array(o); ++n < o; )
    a[n] = t[n + e];
  return a;
}
function cc(t, e, r) {
  var n = t.length;
  return r = r === void 0 ? n : r, ic(t, e, r);
}
var uc = "\\ud800-\\udfff", lc = "\\u0300-\\u036f", fc = "\\ufe20-\\ufe2f", dc = "\\u20d0-\\u20ff", pc = lc + fc + dc, hc = "\\ufe0e\\ufe0f", gc = "\\u200d", vc = RegExp("[" + gc + uc + pc + hc + "]");
function Eo(t) {
  return vc.test(t);
}
function mc(t) {
  return t.split("");
}
var $o = "\\ud800-\\udfff", yc = "\\u0300-\\u036f", bc = "\\ufe20-\\ufe2f", _c = "\\u20d0-\\u20ff", Sc = yc + bc + _c, Oc = "\\ufe0e\\ufe0f", Ec = "[" + $o + "]", He = "[" + Sc + "]", Je = "\\ud83c[\\udffb-\\udfff]", $c = "(?:" + He + "|" + Je + ")", wo = "[^" + $o + "]", Co = "(?:\\ud83c[\\udde6-\\uddff]){2}", No = "[\\ud800-\\udbff][\\udc00-\\udfff]", wc = "\\u200d", jo = $c + "?", xo = "[" + Oc + "]?", Cc = "(?:" + wc + "(?:" + [wo, Co, No].join("|") + ")" + xo + jo + ")*", Nc = xo + jo + Cc, jc = "(?:" + [wo + He + "?", He, Co, No, Ec].join("|") + ")", xc = RegExp(Je + "(?=" + Je + ")|" + jc + Nc, "g");
function Ac(t) {
  return t.match(xc) || [];
}
function Tc(t) {
  return Eo(t) ? Ac(t) : mc(t);
}
function Rc(t) {
  return function(e) {
    e = _o(e);
    var r = Eo(e) ? Tc(e) : void 0, n = r ? r[0] : e.charAt(0), o = r ? cc(r, 1).join("") : e.slice(1);
    return n[t]() + o;
  };
}
var Mc = Rc("toUpperCase");
function Pc(t) {
  return Mc(_o(t).toLowerCase());
}
function Ic() {
  this.__data__ = new at(), this.size = 0;
}
function Dc(t) {
  var e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
function Lc(t) {
  return this.__data__.get(t);
}
function Fc(t) {
  return this.__data__.has(t);
}
var Vc = 200;
function Uc(t, e) {
  var r = this.__data__;
  if (r instanceof at) {
    var n = r.__data__;
    if (!Yt || n.length < Vc - 1)
      return n.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new Ct(n);
  }
  return r.set(t, e), this.size = r.size, this;
}
function nt(t) {
  var e = this.__data__ = new at(t);
  this.size = e.size;
}
nt.prototype.clear = Ic;
nt.prototype.delete = Dc;
nt.prototype.get = Lc;
nt.prototype.has = Fc;
nt.prototype.set = Uc;
var Ao = typeof exports == "object" && exports && !exports.nodeType && exports, nn = Ao && typeof module == "object" && module && !module.nodeType && module, Bc = nn && nn.exports === Ao, on = Bc ? X.Buffer : void 0;
on && on.allocUnsafe;
function Gc(t, e) {
  return t.slice();
}
function zc(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, o = 0, a = []; ++r < n; ) {
    var s = t[r];
    e(s, r, t) && (a[o++] = s);
  }
  return a;
}
function kc() {
  return [];
}
var Hc = Object.prototype, Jc = Hc.propertyIsEnumerable, an = Object.getOwnPropertySymbols, Wc = an ? function(t) {
  return t == null ? [] : (t = Object(t), zc(an(t), function(e) {
    return Jc.call(t, e);
  }));
} : kc;
function qc(t, e, r) {
  var n = e(t);
  return ot(t) ? n : ec(n, r(t));
}
function sn(t) {
  return qc(t, Ci, Wc);
}
var We = wt(X, "DataView"), qe = wt(X, "Promise"), Ke = wt(X, "Set"), cn = "[object Map]", Kc = "[object Object]", un = "[object Promise]", ln = "[object Set]", fn = "[object WeakMap]", dn = "[object DataView]", Qc = $t(We), Yc = $t(Yt), Xc = $t(qe), Zc = $t(Ke), tu = $t(ze), ut = Ot;
(We && ut(new We(new ArrayBuffer(1))) != dn || Yt && ut(new Yt()) != cn || qe && ut(qe.resolve()) != un || Ke && ut(new Ke()) != ln || ze && ut(new ze()) != fn) && (ut = function(t) {
  var e = Ot(t), r = e == Kc ? t.constructor : void 0, n = r ? $t(r) : "";
  if (n)
    switch (n) {
      case Qc:
        return dn;
      case Yc:
        return cn;
      case Xc:
        return un;
      case Zc:
        return ln;
      case tu:
        return fn;
    }
  return e;
});
var ve = X.Uint8Array;
function eu(t) {
  var e = new t.constructor(t.byteLength);
  return new ve(e).set(new ve(t)), e;
}
function ru(t, e) {
  var r = eu(t.buffer);
  return new t.constructor(r, t.byteOffset, t.length);
}
function nu(t) {
  return typeof t.constructor == "function" && !hr(t) ? ys(So(t)) : {};
}
var ou = "__lodash_hash_undefined__";
function au(t) {
  return this.__data__.set(t, ou), this;
}
function su(t) {
  return this.__data__.has(t);
}
function me(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.__data__ = new Ct(); ++e < r; )
    this.add(t[e]);
}
me.prototype.add = me.prototype.push = au;
me.prototype.has = su;
function iu(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n; )
    if (e(t[r], r, t))
      return !0;
  return !1;
}
function cu(t, e) {
  return t.has(e);
}
var uu = 1, lu = 2;
function To(t, e, r, n, o, a) {
  var s = r & uu, i = t.length, c = e.length;
  if (i != c && !(s && c > i))
    return !1;
  var u = a.get(t), d = a.get(e);
  if (u && d)
    return u == e && d == t;
  var f = -1, l = !0, h = r & lu ? new me() : void 0;
  for (a.set(t, e), a.set(e, t); ++f < i; ) {
    var v = t[f], _ = e[f];
    if (n)
      var p = s ? n(_, v, f, e, t, a) : n(v, _, f, t, e, a);
    if (p !== void 0) {
      if (p)
        continue;
      l = !1;
      break;
    }
    if (h) {
      if (!iu(e, function(g, m) {
        if (!cu(h, m) && (v === g || o(v, g, r, n, a)))
          return h.push(m);
      })) {
        l = !1;
        break;
      }
    } else if (!(v === _ || o(v, _, r, n, a))) {
      l = !1;
      break;
    }
  }
  return a.delete(t), a.delete(e), l;
}
function fu(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n, o) {
    r[++e] = [o, n];
  }), r;
}
function du(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n) {
    r[++e] = n;
  }), r;
}
var pu = 1, hu = 2, gu = "[object Boolean]", vu = "[object Date]", mu = "[object Error]", yu = "[object Map]", bu = "[object Number]", _u = "[object RegExp]", Su = "[object Set]", Ou = "[object String]", Eu = "[object Symbol]", $u = "[object ArrayBuffer]", wu = "[object DataView]", pn = lt ? lt.prototype : void 0, Ie = pn ? pn.valueOf : void 0;
function Cu(t, e, r, n, o, a, s) {
  switch (r) {
    case wu:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case $u:
      return !(t.byteLength != e.byteLength || !a(new ve(t), new ve(e)));
    case gu:
    case vu:
    case bu:
      return ae(+t, +e);
    case mu:
      return t.name == e.name && t.message == e.message;
    case _u:
    case Ou:
      return t == e + "";
    case yu:
      var i = fu;
    case Su:
      var c = n & pu;
      if (i || (i = du), t.size != e.size && !c)
        return !1;
      var u = s.get(t);
      if (u)
        return u == e;
      n |= hu, s.set(t, e);
      var d = To(i(t), i(e), n, o, a, s);
      return s.delete(t), d;
    case Eu:
      if (Ie)
        return Ie.call(t) == Ie.call(e);
  }
  return !1;
}
var Nu = 1, ju = Object.prototype, xu = ju.hasOwnProperty;
function Au(t, e, r, n, o, a) {
  var s = r & Nu, i = sn(t), c = i.length, u = sn(e), d = u.length;
  if (c != d && !s)
    return !1;
  for (var f = c; f--; ) {
    var l = i[f];
    if (!(s ? l in e : xu.call(e, l)))
      return !1;
  }
  var h = a.get(t), v = a.get(e);
  if (h && v)
    return h == e && v == t;
  var _ = !0;
  a.set(t, e), a.set(e, t);
  for (var p = s; ++f < c; ) {
    l = i[f];
    var g = t[l], m = e[l];
    if (n)
      var b = s ? n(m, g, l, e, t, a) : n(g, m, l, t, e, a);
    if (!(b === void 0 ? g === m || o(g, m, r, n, a) : b)) {
      _ = !1;
      break;
    }
    p || (p = l == "constructor");
  }
  if (_ && !p) {
    var y = t.constructor, S = e.constructor;
    y != S && "constructor" in t && "constructor" in e && !(typeof y == "function" && y instanceof y && typeof S == "function" && S instanceof S) && (_ = !1);
  }
  return a.delete(t), a.delete(e), _;
}
var Tu = 1, hn = "[object Arguments]", gn = "[object Array]", le = "[object Object]", Ru = Object.prototype, vn = Ru.hasOwnProperty;
function Mu(t, e, r, n, o, a) {
  var s = ot(t), i = ot(e), c = s ? gn : ut(t), u = i ? gn : ut(e);
  c = c == hn ? le : c, u = u == hn ? le : u;
  var d = c == le, f = u == le, l = c == u;
  if (l && ge(t)) {
    if (!ge(e))
      return !1;
    s = !0, d = !1;
  }
  if (l && !d)
    return a || (a = new nt()), s || gr(t) ? To(t, e, r, n, o, a) : Cu(t, e, c, r, n, o, a);
  if (!(r & Tu)) {
    var h = d && vn.call(t, "__wrapped__"), v = f && vn.call(e, "__wrapped__");
    if (h || v) {
      var _ = h ? t.value() : t, p = v ? e.value() : e;
      return a || (a = new nt()), o(_, p, r, n, a);
    }
  }
  return l ? (a || (a = new nt()), Au(t, e, r, n, o, a)) : !1;
}
function Ro(t, e, r, n, o) {
  return t === e ? !0 : t == null || e == null || !ft(t) && !ft(e) ? t !== t && e !== e : Mu(t, e, r, n, Ro, o);
}
function Pu(t) {
  return function(e, r, n) {
    for (var o = -1, a = Object(e), s = n(e), i = s.length; i--; ) {
      var c = s[++o];
      if (r(a[c], c, a) === !1)
        break;
    }
    return e;
  };
}
var Iu = Pu();
function Qe(t, e, r) {
  (r !== void 0 && !ae(t[e], r) || r === void 0 && !(e in t)) && pr(t, e, r);
}
function Du(t) {
  return ft(t) && Oe(t);
}
function Ye(t, e) {
  if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
    return t[e];
}
function Lu(t) {
  return Ms(t, bo(t));
}
function Fu(t, e, r, n, o, a, s) {
  var i = Ye(t, r), c = Ye(e, r), u = s.get(c);
  if (u) {
    Qe(t, r, u);
    return;
  }
  var d = a ? a(i, c, r + "", t, e, s) : void 0, f = d === void 0;
  if (f) {
    var l = ot(c), h = !l && ge(c), v = !l && !h && gr(c);
    d = c, l || h || v ? ot(i) ? d = i : Du(i) ? d = _s(i) : h ? (f = !1, d = Gc(c)) : v ? (f = !1, d = ru(c)) : d = [] : Ft(c) || ke(c) ? (d = i, ke(i) ? d = Lu(i) : (!Et(i) || dr(i)) && (d = nu(c))) : f = !1;
  }
  f && (s.set(c, d), o(d, c, n, a, s), s.delete(c)), Qe(t, r, d);
}
function Mo(t, e, r, n, o) {
  t !== e && Iu(e, function(a, s) {
    if (o || (o = new nt()), Et(a))
      Fu(t, e, s, r, Mo, n, o);
    else {
      var i = n ? n(Ye(t, s), a, s + "", t, e, o) : void 0;
      i === void 0 && (i = a), Qe(t, s, i);
    }
  }, bo);
}
function Vu(t, e) {
  return Ro(t, e);
}
var Uu = Fs(function(t, e, r) {
  Mo(t, e, r);
});
const mn = (t, e = {
  keyListVar: "ALL_NODE_IDS",
  getReadValCode: ""
}) => {
  let r = t;
  return r[0] === String(Number(r[0])) && (r = `_${r}`), `
var ${t} = {};

${e.keyListVar}.forEach(function (key) {
  var tempK = /^\\d/.test(key) ? ('_' + key) : key;
  Object.defineProperty(${t}, tempK, {
    get: function () {
      ${e.getReadValCode}
    },
    set: function (value) {},
    enumerable: true
  });
});
`;
}, Sv = function(t) {
  return !(!t || typeof t != "function" || !t.prototype);
};
function Bu(t) {
  const e = t == null ? void 0 : t.prototype;
  return !!(e && e.isReactComponent);
}
function Gu(t) {
  var n, o;
  const r = typeof Symbol == "function" && Symbol.for ? Symbol.for("react.forward_ref") : 60112;
  return (t == null ? void 0 : t.$$typeof) === r || ((n = t == null ? void 0 : t.prototype) == null ? void 0 : n.isReactComponent) || ((o = t == null ? void 0 : t.prototype) == null ? void 0 : o.setState) || t._forwardRef;
}
function zu(t) {
  class e extends Va {
    render() {
      return Ua(t, this.props);
    }
  }
  return e.displayName = t.displayName, e;
}
const At = (t, e) => {
  const r = (n) => {
    let o = `function run () { return ${n}; }`;
    return String(n).includes("return ") && (o = `function runExp () { ${n} }`), se({
      funcBody: o,
      funcName: "run",
      nodeContext: e.nodeContext,
      storeManager: e.storeManager,
      nodeModel: e.nodeModel
    })();
  };
  try {
    return r(t);
  } catch (n) {
    console.warn(n);
    const o = `[${t}] expression run failed`;
    return console.warn(o), null;
  }
}, se = (t) => {
  const {
    funcBody: e,
    funcName: r,
    nodeContext: n,
    storeManager: o,
    $$response: a,
    nodeModel: s,
    actionVariableSpace: i
  } = t, c = r || "anonymous";
  return {
    [c]: function(...d) {
      let f;
      const h = Object.keys(i || {}).map((v) => `var ${v} = $ACTION_VAR_SPACE[${JSON.stringify(v)}];`);
      try {
        return f = `
  var $$$__args__$$$ = Array.from(arguments);
  function $$_run_$$() {
    var __extraParams = $$$__args__$$$.pop();
    var __$$storeManager__ = __extraParams.storeManager;
    var $ALL_NODE_IDS = Array.from(__$$storeManager__.storeMap.keys().filter(Boolean));;
    var $RESPONSE = __extraParams.$$response;;
    var $CTX =  __extraParams.$$context;
    var $$context = $CTX;
    var $PARAMS = $$context.params || {};
    var $EVENT_PARAMS = $$$__args__$$$[0];
    var $Event = $$$__args__$$$[0];
    var $EVENT = $$$__args__$$$[0];
    var $ARGS = $$$__args__$$$;

    var $ACTION_VAR_SPACE = __extraParams.actionVariableSpace;
    // 新增的变量
    var $N_ID = ${JSON.stringify(s.id)};
    var $NODE_MODAL = __extraParams.nodeModel;
    var $IDS = $ALL_NODE_IDS.reduce(function (res, id) {
        res[id] = id;
        return res;
    }, {});
    var $M = {};
    var $G_STATE = __$$storeManager__.getState('globalState');
    var $STATE = __$$storeManager__.getState($N_ID);
    var $LOOP_DATA = $CTX.loopData;


${mn("$ALL_STATE", {
          keyListVar: "$ALL_NODE_IDS ",
          getReadValCode: "return __$$storeManager__.getState(key);"
        })}

${mn("$U_STATE", {
          keyListVar: "$ALL_NODE_IDS ",
          getReadValCode: "return function (newVal) { __$$storeManager__.setState(key, newVal); }"
        })}

    $$context.stateManager = __$$storeManager__.getStateSnapshot();
    // action flowACTION_VAR_SPACE 中定义的变量
    ${h.join(`;
`)}

    var $$_f_$$ = ${e.trim() || "function () {}"};

    return $$_f_$$.apply($$_f_$$, $$$__args__$$$);
  }
  return $$_run_$$();
        `, new Function(f)(...d, { $$context: n, storeManager: o, $$response: a, actionVariableSpace: i, nodeModel: s });
      } catch (v) {
        console.warn(v);
      }
    }
  }[c];
}, Po = (t, e) => {
  const r = {};
  return e.forEach((n, o) => {
    r[n] = t[o];
  }), r;
}, ku = (t = []) => {
  const e = {};
  return t.forEach(({ property: r, value: n }) => {
    let o = r.replace("-webkit", "Webkit");
    o = o.replace("-ms", "ms"), o = o.replace("-moz", "Moz"), o = o.replace("-o", "O");
    let a = o.split("-");
    a.length >= 2 && (a = a.map((s, i) => i !== 0 ? Pc(s) : s)), e[a.join("")] = n;
  }), e;
}, Ov = (t) => {
  let e = "";
  return Object.keys(t || {}).forEach((r) => {
    e += `${r}:${t[r]};`;
  }), e;
}, Ev = (t, e) => {
  const r = {};
  return t.forEach((n) => {
    if (n.globalName) {
      const o = e[n.globalName];
      o && (r[n.globalName] = o, o.__esModule && o.default && (r[n.globalName] = o.default));
    }
  }), r;
}, $v = (t, e = 1) => {
  let r = 0, n = t, o = {}, a = {};
  for (; r < e; )
    Object.keys(n).forEach((s) => {
      o = {
        ...o,
        ...n[s]
      };
    }), a = o, n = o, o = {}, r += 1;
  return a;
}, Hu = (t, e) => {
  const r = [];
  return e.forEach((n) => {
    const a = n.exec(t);
    a != null && a.length && r.push(a[1]);
  }), r;
}, Io = (t, e) => {
  const r = {};
  return e.forEach((n) => {
    t[n.name] && (r[n.name] = t[n.name]);
  }), r;
}, wv = (t, e) => Io(t, e), Cv = (t, e) => Io(t, e), yn = (t) => {
  var r;
  return ((r = t.value.css) == null ? void 0 : r.class) || `c_${t.id}`;
}, Ju = (t, e) => {
  const r = t.split(".");
  let n, o = e;
  return r.forEach((a) => {
    n = o == null ? void 0 : o[a], o = n;
  }), n || (() => `Component [${t}] not found`);
}, bn = (t, e) => {
  const r = {
    ...t
  };
  return r.__proto__ = e, r;
}, Wu = {}, _n = (t) => {
  let e;
  const r = /* @__PURE__ */ new Set(), n = (d, f) => {
    const l = typeof d == "function" ? d(e) : d;
    if (!Object.is(l, e)) {
      const h = e;
      e = f ?? (typeof l != "object" || l === null) ? l : Object.assign({}, e, l), r.forEach((v) => v(e, h));
    }
  }, o = () => e, c = { setState: n, getState: o, getInitialState: () => u, subscribe: (d) => (r.add(d), () => r.delete(d)), destroy: () => {
    (Wu ? "production" : void 0) !== "production" && console.warn(
      "[DEPRECATED] The `destroy` method will be unsupported in a future version. Instead use unsubscribe function returned by subscribe. Everything will be garbage-collected if store is garbage-collected."
    ), r.clear();
  } }, u = e = t(n, o, c);
  return c;
}, qu = (t) => t ? _n(t) : _n;
class Ku {
  constructor() {
    $(this, "storeMap", /* @__PURE__ */ new Map());
  }
  addStore(e, r) {
    const n = qu(r);
    return this.storeMap.set(e, n), n.name = e, n;
  }
  setStore(e, r) {
    this.storeMap.set(e, r);
  }
  removeStore(e) {
    this.storeMap.delete(e);
  }
  getStore(e) {
    return this.storeMap.get(e);
  }
  getState(e) {
    var r;
    return (r = this.storeMap.get(e)) == null ? void 0 : r.getState();
  }
  getStateObj(e) {
    return {
      state: this.getState(e),
      updateState: (r) => {
        this.setState(e, r);
      }
    };
  }
  setState(e, r) {
    var n;
    return (n = this.storeMap.get(e)) == null ? void 0 : n.setState(r);
  }
  connect(e, r) {
    const n = this.storeMap.get(e);
    return n ? n.subscribe(r) : (console.warn("store not exits"), () => {
    });
  }
  /**
   * storeManger 赋值以及 获取需要做转换
   */
  getStateSnapshot() {
    const e = {};
    return this.storeMap.forEach((r, n) => {
      e[n] = this.getStateObj(n);
    }), e;
  }
  destroy() {
    this.storeMap = /* @__PURE__ */ new Map();
  }
}
class Qu {
  constructor() {
    $(this, "varSpace", /* @__PURE__ */ new Map());
  }
  get(e) {
    return this.varSpace.get(e);
  }
  add(e, r) {
    this.varSpace.set(e, r);
  }
  remove(e) {
    this.varSpace.delete(e);
  }
  destroy() {
    this.varSpace.clear();
  }
  getStateSnapshot() {
    const e = {};
    return this.varSpace.forEach((r, n) => {
      e[n] = r;
    }), e;
  }
}
class Do {
  constructor() {
    $(this, "refMap", /* @__PURE__ */ new Map());
  }
  get(e) {
    return this.refMap.get(e);
  }
  add(e, r) {
    this.refMap.set(e, r);
  }
  remove(e) {
    this.refMap.delete(e);
  }
  destroy() {
    this.refMap.clear();
  }
}
var Yu = Object.defineProperty, Xu = (t, e, r) => e in t ? Yu(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, C = (t, e, r) => Xu(t, typeof e != "symbol" ? e + "" : e, r), Lo = typeof global == "object" && global && global.Object === Object && global, Zu = typeof self == "object" && self && self.Object === Object && self, Z = Lo || Zu || Function("return this")(), J = Z.Symbol, Fo = Object.prototype, tl = Fo.hasOwnProperty, el = Fo.toString, Ht = J ? J.toStringTag : void 0;
function rl(t) {
  var e = tl.call(t, Ht), r = t[Ht];
  try {
    t[Ht] = void 0;
    var n = !0;
  } catch {
  }
  var o = el.call(t);
  return n && (e ? t[Ht] = r : delete t[Ht]), o;
}
var nl = Object.prototype, ol = nl.toString;
function al(t) {
  return ol.call(t);
}
var sl = "[object Null]", il = "[object Undefined]", Sn = J ? J.toStringTag : void 0;
function Nt(t) {
  return t == null ? t === void 0 ? il : sl : Sn && Sn in Object(t) ? rl(t) : al(t);
}
function Y(t) {
  return t != null && typeof t == "object";
}
var cl = "[object Symbol]";
function vr(t) {
  return typeof t == "symbol" || Y(t) && Nt(t) == cl;
}
function mr(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, o = Array(n); ++r < n; )
    o[r] = e(t[r], r, t);
  return o;
}
var L = Array.isArray, On = J ? J.prototype : void 0, En = On ? On.toString : void 0;
function Vo(t) {
  if (typeof t == "string")
    return t;
  if (L(t))
    return mr(t, Vo) + "";
  if (vr(t))
    return En ? En.call(t) : "";
  var e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
function Q(t) {
  var e = typeof t;
  return t != null && (e == "object" || e == "function");
}
function yr(t) {
  return t;
}
var ul = "[object AsyncFunction]", ll = "[object Function]", fl = "[object GeneratorFunction]", dl = "[object Proxy]";
function br(t) {
  if (!Q(t))
    return !1;
  var e = Nt(t);
  return e == ll || e == fl || e == ul || e == dl;
}
var De = Z["__core-js_shared__"], $n = function() {
  var t = /[^.]+$/.exec(De && De.keys && De.keys.IE_PROTO || "");
  return t ? "Symbol(src)_1." + t : "";
}();
function pl(t) {
  return !!$n && $n in t;
}
var hl = Function.prototype, gl = hl.toString;
function jt(t) {
  if (t != null) {
    try {
      return gl.call(t);
    } catch {
    }
    try {
      return t + "";
    } catch {
    }
  }
  return "";
}
var vl = /[\\^$.*+?()[\]{}|]/g, ml = /^\[object .+?Constructor\]$/, yl = Function.prototype, bl = Object.prototype, _l = yl.toString, Sl = bl.hasOwnProperty, Ol = RegExp(
  "^" + _l.call(Sl).replace(vl, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
);
function El(t) {
  if (!Q(t) || pl(t))
    return !1;
  var e = br(t) ? Ol : ml;
  return e.test(jt(t));
}
function $l(t, e) {
  return t == null ? void 0 : t[e];
}
function xt(t, e) {
  var r = $l(t, e);
  return El(r) ? r : void 0;
}
var Xe = xt(Z, "WeakMap"), wn = Object.create, wl = /* @__PURE__ */ function() {
  function t() {
  }
  return function(e) {
    if (!Q(e))
      return {};
    if (wn)
      return wn(e);
    t.prototype = e;
    var r = new t();
    return t.prototype = void 0, r;
  };
}();
function Cl(t, e, r) {
  switch (r.length) {
    case 0:
      return t.call(e);
    case 1:
      return t.call(e, r[0]);
    case 2:
      return t.call(e, r[0], r[1]);
    case 3:
      return t.call(e, r[0], r[1], r[2]);
  }
  return t.apply(e, r);
}
function Nl() {
}
function Uo(t, e) {
  var r = -1, n = t.length;
  for (e || (e = Array(n)); ++r < n; )
    e[r] = t[r];
  return e;
}
var jl = 800, xl = 16, Al = Date.now;
function Tl(t) {
  var e = 0, r = 0;
  return function() {
    var n = Al(), o = xl - (n - r);
    if (r = n, o > 0) {
      if (++e >= jl)
        return arguments[0];
    } else
      e = 0;
    return t.apply(void 0, arguments);
  };
}
function Rl(t) {
  return function() {
    return t;
  };
}
var ye = function() {
  try {
    var t = xt(Object, "defineProperty");
    return t({}, "", {}), t;
  } catch {
  }
}(), Ml = ye ? function(t, e) {
  return ye(t, "toString", {
    configurable: !0,
    enumerable: !1,
    value: Rl(e),
    writable: !0
  });
} : yr, Bo = Tl(Ml);
function Pl(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n && e(t[r], r, t) !== !1; )
    ;
  return t;
}
function Il(t, e, r, n) {
  for (var o = t.length, a = r + -1; ++a < o; )
    if (e(t[a], a, t))
      return a;
  return -1;
}
function Dl(t) {
  return t !== t;
}
function Ll(t, e, r) {
  for (var n = r - 1, o = t.length; ++n < o; )
    if (t[n] === e)
      return n;
  return -1;
}
function Fl(t, e, r) {
  return e === e ? Ll(t, e, r) : Il(t, Dl, r);
}
function Vl(t, e) {
  var r = t == null ? 0 : t.length;
  return !!r && Fl(t, e, 0) > -1;
}
var Ul = 9007199254740991, Bl = /^(?:0|[1-9]\d*)$/;
function we(t, e) {
  var r = typeof t;
  return e = e ?? Ul, !!e && (r == "number" || r != "symbol" && Bl.test(t)) && t > -1 && t % 1 == 0 && t < e;
}
function _r(t, e, r) {
  e == "__proto__" && ye ? ye(t, e, {
    configurable: !0,
    enumerable: !0,
    value: r,
    writable: !0
  }) : t[e] = r;
}
function ie(t, e) {
  return t === e || t !== t && e !== e;
}
var Gl = Object.prototype, zl = Gl.hasOwnProperty;
function Sr(t, e, r) {
  var n = t[e];
  (!(zl.call(t, e) && ie(n, r)) || r === void 0 && !(e in t)) && _r(t, e, r);
}
function Vt(t, e, r, n) {
  var o = !r;
  r || (r = {});
  for (var a = -1, s = e.length; ++a < s; ) {
    var i = e[a], c = void 0;
    c === void 0 && (c = t[i]), o ? _r(r, i, c) : Sr(r, i, c);
  }
  return r;
}
var Cn = Math.max;
function Go(t, e, r) {
  return e = Cn(e === void 0 ? t.length - 1 : e, 0), function() {
    for (var n = arguments, o = -1, a = Cn(n.length - e, 0), s = Array(a); ++o < a; )
      s[o] = n[e + o];
    o = -1;
    for (var i = Array(e + 1); ++o < e; )
      i[o] = n[o];
    return i[e] = r(s), Cl(t, this, i);
  };
}
function zo(t, e) {
  return Bo(Go(t, e, yr), t + "");
}
var kl = 9007199254740991;
function Or(t) {
  return typeof t == "number" && t > -1 && t % 1 == 0 && t <= kl;
}
function Ce(t) {
  return t != null && Or(t.length) && !br(t);
}
function Hl(t, e, r) {
  if (!Q(r))
    return !1;
  var n = typeof e;
  return (n == "number" ? Ce(r) && we(e, r.length) : n == "string" && e in r) ? ie(r[e], t) : !1;
}
function Jl(t) {
  return zo(function(e, r) {
    var n = -1, o = r.length, a = o > 1 ? r[o - 1] : void 0, s = o > 2 ? r[2] : void 0;
    for (a = t.length > 3 && typeof a == "function" ? (o--, a) : void 0, s && Hl(r[0], r[1], s) && (a = o < 3 ? void 0 : a, o = 1), e = Object(e); ++n < o; ) {
      var i = r[n];
      i && t(e, i, n, a);
    }
    return e;
  });
}
var Wl = Object.prototype;
function Er(t) {
  var e = t && t.constructor, r = typeof e == "function" && e.prototype || Wl;
  return t === r;
}
function ql(t, e) {
  for (var r = -1, n = Array(t); ++r < t; )
    n[r] = e(r);
  return n;
}
var Kl = "[object Arguments]";
function Nn(t) {
  return Y(t) && Nt(t) == Kl;
}
var ko = Object.prototype, Ql = ko.hasOwnProperty, Yl = ko.propertyIsEnumerable, Xt = Nn(/* @__PURE__ */ function() {
  return arguments;
}()) ? Nn : function(t) {
  return Y(t) && Ql.call(t, "callee") && !Yl.call(t, "callee");
};
function Xl() {
  return !1;
}
var Ho = typeof exports == "object" && exports && !exports.nodeType && exports, jn = Ho && typeof module == "object" && module && !module.nodeType && module, Zl = jn && jn.exports === Ho, xn = Zl ? Z.Buffer : void 0, tf = xn ? xn.isBuffer : void 0, Zt = tf || Xl, ef = "[object Arguments]", rf = "[object Array]", nf = "[object Boolean]", of = "[object Date]", af = "[object Error]", sf = "[object Function]", cf = "[object Map]", uf = "[object Number]", lf = "[object Object]", ff = "[object RegExp]", df = "[object Set]", pf = "[object String]", hf = "[object WeakMap]", gf = "[object ArrayBuffer]", vf = "[object DataView]", mf = "[object Float32Array]", yf = "[object Float64Array]", bf = "[object Int8Array]", _f = "[object Int16Array]", Sf = "[object Int32Array]", Of = "[object Uint8Array]", Ef = "[object Uint8ClampedArray]", $f = "[object Uint16Array]", wf = "[object Uint32Array]", P = {};
P[mf] = P[yf] = P[bf] = P[_f] = P[Sf] = P[Of] = P[Ef] = P[$f] = P[wf] = !0;
P[ef] = P[rf] = P[gf] = P[nf] = P[vf] = P[of] = P[af] = P[sf] = P[cf] = P[uf] = P[lf] = P[ff] = P[df] = P[pf] = P[hf] = !1;
function Cf(t) {
  return Y(t) && Or(t.length) && !!P[Nt(t)];
}
function $r(t) {
  return function(e) {
    return t(e);
  };
}
var Jo = typeof exports == "object" && exports && !exports.nodeType && exports, Wt = Jo && typeof module == "object" && module && !module.nodeType && module, Nf = Wt && Wt.exports === Jo, Le = Nf && Lo.process, Mt = function() {
  try {
    var t = Wt && Wt.require && Wt.require("util").types;
    return t || Le && Le.binding && Le.binding("util");
  } catch {
  }
}(), An = Mt && Mt.isTypedArray, wr = An ? $r(An) : Cf, jf = Object.prototype, xf = jf.hasOwnProperty;
function Wo(t, e) {
  var r = L(t), n = !r && Xt(t), o = !r && !n && Zt(t), a = !r && !n && !o && wr(t), s = r || n || o || a, i = s ? ql(t.length, String) : [], c = i.length;
  for (var u in t)
    (e || xf.call(t, u)) && !(s && // Safari 9 has enumerable `arguments.length` in strict mode.
    (u == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
    o && (u == "offset" || u == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
    a && (u == "buffer" || u == "byteLength" || u == "byteOffset") || // Skip index properties.
    we(u, c))) && i.push(u);
  return i;
}
function qo(t, e) {
  return function(r) {
    return t(e(r));
  };
}
var Af = qo(Object.keys, Object), Tf = Object.prototype, Rf = Tf.hasOwnProperty;
function Mf(t) {
  if (!Er(t))
    return Af(t);
  var e = [];
  for (var r in Object(t))
    Rf.call(t, r) && r != "constructor" && e.push(r);
  return e;
}
function Ne(t) {
  return Ce(t) ? Wo(t) : Mf(t);
}
function Pf(t) {
  var e = [];
  if (t != null)
    for (var r in Object(t))
      e.push(r);
  return e;
}
var If = Object.prototype, Df = If.hasOwnProperty;
function Lf(t) {
  if (!Q(t))
    return Pf(t);
  var e = Er(t), r = [];
  for (var n in t)
    n == "constructor" && (e || !Df.call(t, n)) || r.push(n);
  return r;
}
function ce(t) {
  return Ce(t) ? Wo(t, !0) : Lf(t);
}
var Ff = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, Vf = /^\w*$/;
function Cr(t, e) {
  if (L(t))
    return !1;
  var r = typeof t;
  return r == "number" || r == "symbol" || r == "boolean" || t == null || vr(t) ? !0 : Vf.test(t) || !Ff.test(t) || e != null && t in Object(e);
}
var te = xt(Object, "create");
function Uf() {
  this.__data__ = te ? te(null) : {}, this.size = 0;
}
function Bf(t) {
  var e = this.has(t) && delete this.__data__[t];
  return this.size -= e ? 1 : 0, e;
}
var Gf = "__lodash_hash_undefined__", zf = Object.prototype, kf = zf.hasOwnProperty;
function Hf(t) {
  var e = this.__data__;
  if (te) {
    var r = e[t];
    return r === Gf ? void 0 : r;
  }
  return kf.call(e, t) ? e[t] : void 0;
}
var Jf = Object.prototype, Wf = Jf.hasOwnProperty;
function qf(t) {
  var e = this.__data__;
  return te ? e[t] !== void 0 : Wf.call(e, t);
}
var Kf = "__lodash_hash_undefined__";
function Qf(t, e) {
  var r = this.__data__;
  return this.size += this.has(t) ? 0 : 1, r[t] = te && e === void 0 ? Kf : e, this;
}
function _t(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
_t.prototype.clear = Uf;
_t.prototype.delete = Bf;
_t.prototype.get = Hf;
_t.prototype.has = qf;
_t.prototype.set = Qf;
function Yf() {
  this.__data__ = [], this.size = 0;
}
function je(t, e) {
  for (var r = t.length; r--; )
    if (ie(t[r][0], e))
      return r;
  return -1;
}
var Xf = Array.prototype, Zf = Xf.splice;
function td(t) {
  var e = this.__data__, r = je(e, t);
  if (r < 0)
    return !1;
  var n = e.length - 1;
  return r == n ? e.pop() : Zf.call(e, r, 1), --this.size, !0;
}
function ed(t) {
  var e = this.__data__, r = je(e, t);
  return r < 0 ? void 0 : e[r][1];
}
function rd(t) {
  return je(this.__data__, t) > -1;
}
function nd(t, e) {
  var r = this.__data__, n = je(r, t);
  return n < 0 ? (++this.size, r.push([t, e])) : r[n][1] = e, this;
}
function st(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
st.prototype.clear = Yf;
st.prototype.delete = td;
st.prototype.get = ed;
st.prototype.has = rd;
st.prototype.set = nd;
var ee = xt(Z, "Map");
function od() {
  this.size = 0, this.__data__ = {
    hash: new _t(),
    map: new (ee || st)(),
    string: new _t()
  };
}
function ad(t) {
  var e = typeof t;
  return e == "string" || e == "number" || e == "symbol" || e == "boolean" ? t !== "__proto__" : t === null;
}
function xe(t, e) {
  var r = t.__data__;
  return ad(e) ? r[typeof e == "string" ? "string" : "hash"] : r.map;
}
function sd(t) {
  var e = xe(this, t).delete(t);
  return this.size -= e ? 1 : 0, e;
}
function id(t) {
  return xe(this, t).get(t);
}
function cd(t) {
  return xe(this, t).has(t);
}
function ud(t, e) {
  var r = xe(this, t), n = r.size;
  return r.set(t, e), this.size += r.size == n ? 0 : 1, this;
}
function it(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.clear(); ++e < r; ) {
    var n = t[e];
    this.set(n[0], n[1]);
  }
}
it.prototype.clear = od;
it.prototype.delete = sd;
it.prototype.get = id;
it.prototype.has = cd;
it.prototype.set = ud;
var ld = "Expected a function";
function Nr(t, e) {
  if (typeof t != "function" || e != null && typeof e != "function")
    throw new TypeError(ld);
  var r = function() {
    var n = arguments, o = e ? e.apply(this, n) : n[0], a = r.cache;
    if (a.has(o))
      return a.get(o);
    var s = t.apply(this, n);
    return r.cache = a.set(o, s) || a, s;
  };
  return r.cache = new (Nr.Cache || it)(), r;
}
Nr.Cache = it;
var fd = 500;
function dd(t) {
  var e = Nr(t, function(n) {
    return r.size === fd && r.clear(), n;
  }), r = e.cache;
  return e;
}
var pd = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g, hd = /\\(\\)?/g, gd = dd(function(t) {
  var e = [];
  return t.charCodeAt(0) === 46 && e.push(""), t.replace(pd, function(r, n, o, a) {
    e.push(o ? a.replace(hd, "$1") : n || r);
  }), e;
});
function vd(t) {
  return t == null ? "" : Vo(t);
}
function Ut(t, e) {
  return L(t) ? t : Cr(t, e) ? [t] : gd(vd(t));
}
function Bt(t) {
  if (typeof t == "string" || vr(t))
    return t;
  var e = t + "";
  return e == "0" && 1 / t == -1 / 0 ? "-0" : e;
}
function Ae(t, e) {
  e = Ut(e, t);
  for (var r = 0, n = e.length; t != null && r < n; )
    t = t[Bt(e[r++])];
  return r && r == n ? t : void 0;
}
function Ko(t, e, r) {
  var n = t == null ? void 0 : Ae(t, e);
  return n === void 0 ? r : n;
}
function jr(t, e) {
  for (var r = -1, n = e.length, o = t.length; ++r < n; )
    t[o + r] = e[r];
  return t;
}
var Tn = J ? J.isConcatSpreadable : void 0;
function md(t) {
  return L(t) || Xt(t) || !!(Tn && t && t[Tn]);
}
function Qo(t, e, r, n, o) {
  var a = -1, s = t.length;
  for (r || (r = md), o || (o = []); ++a < s; ) {
    var i = t[a];
    r(i) ? jr(o, i) : n || (o[o.length] = i);
  }
  return o;
}
function yd(t) {
  var e = t == null ? 0 : t.length;
  return e ? Qo(t) : [];
}
function bd(t) {
  return Bo(Go(t, void 0, yd), t + "");
}
var xr = qo(Object.getPrototypeOf, Object), _d = "[object Object]", Sd = Function.prototype, Od = Object.prototype, Yo = Sd.toString, Ed = Od.hasOwnProperty, $d = Yo.call(Object);
function B(t) {
  if (!Y(t) || Nt(t) != _d)
    return !1;
  var e = xr(t);
  if (e === null)
    return !0;
  var r = Ed.call(e, "constructor") && e.constructor;
  return typeof r == "function" && r instanceof r && Yo.call(r) == $d;
}
function wd(t, e, r) {
  var n = -1, o = t.length;
  e < 0 && (e = -e > o ? 0 : o + e), r = r > o ? o : r, r < 0 && (r += o), o = e > r ? 0 : r - e >>> 0, e >>>= 0;
  for (var a = Array(o); ++n < o; )
    a[n] = t[n + e];
  return a;
}
function Cd() {
  this.__data__ = new st(), this.size = 0;
}
function Nd(t) {
  var e = this.__data__, r = e.delete(t);
  return this.size = e.size, r;
}
function jd(t) {
  return this.__data__.get(t);
}
function xd(t) {
  return this.__data__.has(t);
}
var Ad = 200;
function Td(t, e) {
  var r = this.__data__;
  if (r instanceof st) {
    var n = r.__data__;
    if (!ee || n.length < Ad - 1)
      return n.push([t, e]), this.size = ++r.size, this;
    r = this.__data__ = new it(n);
  }
  return r.set(t, e), this.size = r.size, this;
}
function q(t) {
  var e = this.__data__ = new st(t);
  this.size = e.size;
}
q.prototype.clear = Cd;
q.prototype.delete = Nd;
q.prototype.get = jd;
q.prototype.has = xd;
q.prototype.set = Td;
function Rd(t, e) {
  return t && Vt(e, Ne(e), t);
}
function Md(t, e) {
  return t && Vt(e, ce(e), t);
}
var Xo = typeof exports == "object" && exports && !exports.nodeType && exports, Rn = Xo && typeof module == "object" && module && !module.nodeType && module, Pd = Rn && Rn.exports === Xo, Mn = Pd ? Z.Buffer : void 0, Pn = Mn ? Mn.allocUnsafe : void 0;
function Zo(t, e) {
  if (e)
    return t.slice();
  var r = t.length, n = Pn ? Pn(r) : new t.constructor(r);
  return t.copy(n), n;
}
function Id(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length, o = 0, a = []; ++r < n; ) {
    var s = t[r];
    e(s, r, t) && (a[o++] = s);
  }
  return a;
}
function ta() {
  return [];
}
var Dd = Object.prototype, Ld = Dd.propertyIsEnumerable, In = Object.getOwnPropertySymbols, Ar = In ? function(t) {
  return t == null ? [] : (t = Object(t), Id(In(t), function(e) {
    return Ld.call(t, e);
  }));
} : ta;
function Fd(t, e) {
  return Vt(t, Ar(t), e);
}
var Vd = Object.getOwnPropertySymbols, ea = Vd ? function(t) {
  for (var e = []; t; )
    jr(e, Ar(t)), t = xr(t);
  return e;
} : ta;
function Ud(t, e) {
  return Vt(t, ea(t), e);
}
function ra(t, e, r) {
  var n = e(t);
  return L(t) ? n : jr(n, r(t));
}
function Ze(t) {
  return ra(t, Ne, Ar);
}
function Tr(t) {
  return ra(t, ce, ea);
}
var tr = xt(Z, "DataView"), er = xt(Z, "Promise"), Tt = xt(Z, "Set"), Dn = "[object Map]", Bd = "[object Object]", Ln = "[object Promise]", Fn = "[object Set]", Vn = "[object WeakMap]", Un = "[object DataView]", Gd = jt(tr), zd = jt(ee), kd = jt(er), Hd = jt(Tt), Jd = jt(Xe), W = Nt;
(tr && W(new tr(new ArrayBuffer(1))) != Un || ee && W(new ee()) != Dn || er && W(er.resolve()) != Ln || Tt && W(new Tt()) != Fn || Xe && W(new Xe()) != Vn) && (W = function(t) {
  var e = Nt(t), r = e == Bd ? t.constructor : void 0, n = r ? jt(r) : "";
  if (n)
    switch (n) {
      case Gd:
        return Un;
      case zd:
        return Dn;
      case kd:
        return Ln;
      case Hd:
        return Fn;
      case Jd:
        return Vn;
    }
  return e;
});
var Wd = Object.prototype, qd = Wd.hasOwnProperty;
function Kd(t) {
  var e = t.length, r = new t.constructor(e);
  return e && typeof t[0] == "string" && qd.call(t, "index") && (r.index = t.index, r.input = t.input), r;
}
var be = Z.Uint8Array;
function Rr(t) {
  var e = new t.constructor(t.byteLength);
  return new be(e).set(new be(t)), e;
}
function Qd(t, e) {
  var r = e ? Rr(t.buffer) : t.buffer;
  return new t.constructor(r, t.byteOffset, t.byteLength);
}
var Yd = /\w*$/;
function Xd(t) {
  var e = new t.constructor(t.source, Yd.exec(t));
  return e.lastIndex = t.lastIndex, e;
}
var Bn = J ? J.prototype : void 0, Gn = Bn ? Bn.valueOf : void 0;
function Zd(t) {
  return Gn ? Object(Gn.call(t)) : {};
}
function na(t, e) {
  var r = e ? Rr(t.buffer) : t.buffer;
  return new t.constructor(r, t.byteOffset, t.length);
}
var tp = "[object Boolean]", ep = "[object Date]", rp = "[object Map]", np = "[object Number]", op = "[object RegExp]", ap = "[object Set]", sp = "[object String]", ip = "[object Symbol]", cp = "[object ArrayBuffer]", up = "[object DataView]", lp = "[object Float32Array]", fp = "[object Float64Array]", dp = "[object Int8Array]", pp = "[object Int16Array]", hp = "[object Int32Array]", gp = "[object Uint8Array]", vp = "[object Uint8ClampedArray]", mp = "[object Uint16Array]", yp = "[object Uint32Array]";
function bp(t, e, r) {
  var n = t.constructor;
  switch (e) {
    case cp:
      return Rr(t);
    case tp:
    case ep:
      return new n(+t);
    case up:
      return Qd(t, r);
    case lp:
    case fp:
    case dp:
    case pp:
    case hp:
    case gp:
    case vp:
    case mp:
    case yp:
      return na(t, r);
    case rp:
      return new n();
    case np:
    case sp:
      return new n(t);
    case op:
      return Xd(t);
    case ap:
      return new n();
    case ip:
      return Zd(t);
  }
}
function oa(t) {
  return typeof t.constructor == "function" && !Er(t) ? wl(xr(t)) : {};
}
var _p = "[object Map]";
function Sp(t) {
  return Y(t) && W(t) == _p;
}
var zn = Mt && Mt.isMap, Op = zn ? $r(zn) : Sp, Ep = "[object Set]";
function $p(t) {
  return Y(t) && W(t) == Ep;
}
var kn = Mt && Mt.isSet, wp = kn ? $r(kn) : $p, Cp = 1, Np = 2, jp = 4, aa = "[object Arguments]", xp = "[object Array]", Ap = "[object Boolean]", Tp = "[object Date]", Rp = "[object Error]", sa = "[object Function]", Mp = "[object GeneratorFunction]", Pp = "[object Map]", Ip = "[object Number]", ia = "[object Object]", Dp = "[object RegExp]", Lp = "[object Set]", Fp = "[object String]", Vp = "[object Symbol]", Up = "[object WeakMap]", Bp = "[object ArrayBuffer]", Gp = "[object DataView]", zp = "[object Float32Array]", kp = "[object Float64Array]", Hp = "[object Int8Array]", Jp = "[object Int16Array]", Wp = "[object Int32Array]", qp = "[object Uint8Array]", Kp = "[object Uint8ClampedArray]", Qp = "[object Uint16Array]", Yp = "[object Uint32Array]", R = {};
R[aa] = R[xp] = R[Bp] = R[Gp] = R[Ap] = R[Tp] = R[zp] = R[kp] = R[Hp] = R[Jp] = R[Wp] = R[Pp] = R[Ip] = R[ia] = R[Dp] = R[Lp] = R[Fp] = R[Vp] = R[qp] = R[Kp] = R[Qp] = R[Yp] = !0;
R[Rp] = R[sa] = R[Up] = !1;
function qt(t, e, r, n, o, a) {
  var s, i = e & Cp, c = e & Np, u = e & jp;
  if (r && (s = o ? r(t, n, o, a) : r(t)), s !== void 0)
    return s;
  if (!Q(t))
    return t;
  var d = L(t);
  if (d) {
    if (s = Kd(t), !i)
      return Uo(t, s);
  } else {
    var f = W(t), l = f == sa || f == Mp;
    if (Zt(t))
      return Zo(t, i);
    if (f == ia || f == aa || l && !o) {
      if (s = c || l ? {} : oa(t), !i)
        return c ? Ud(t, Md(s, t)) : Fd(t, Rd(s, t));
    } else {
      if (!R[f])
        return o ? t : {};
      s = bp(t, f, i);
    }
  }
  a || (a = new q());
  var h = a.get(t);
  if (h)
    return h;
  a.set(t, s), wp(t) ? t.forEach(function(p) {
    s.add(qt(p, e, r, p, t, a));
  }) : Op(t) && t.forEach(function(p, g) {
    s.set(g, qt(p, e, r, g, t, a));
  });
  var v = u ? c ? Tr : Ze : c ? ce : Ne, _ = d ? void 0 : v(t);
  return Pl(_ || t, function(p, g) {
    _ && (g = p, p = t[g]), Sr(s, g, qt(p, e, r, g, t, a));
  }), s;
}
var Xp = 1, Zp = 4;
function ca(t) {
  return qt(t, Xp | Zp);
}
var th = "__lodash_hash_undefined__";
function eh(t) {
  return this.__data__.set(t, th), this;
}
function rh(t) {
  return this.__data__.has(t);
}
function re(t) {
  var e = -1, r = t == null ? 0 : t.length;
  for (this.__data__ = new it(); ++e < r; )
    this.add(t[e]);
}
re.prototype.add = re.prototype.push = eh;
re.prototype.has = rh;
function nh(t, e) {
  for (var r = -1, n = t == null ? 0 : t.length; ++r < n; )
    if (e(t[r], r, t))
      return !0;
  return !1;
}
function ua(t, e) {
  return t.has(e);
}
var oh = 1, ah = 2;
function la(t, e, r, n, o, a) {
  var s = r & oh, i = t.length, c = e.length;
  if (i != c && !(s && c > i))
    return !1;
  var u = a.get(t), d = a.get(e);
  if (u && d)
    return u == e && d == t;
  var f = -1, l = !0, h = r & ah ? new re() : void 0;
  for (a.set(t, e), a.set(e, t); ++f < i; ) {
    var v = t[f], _ = e[f];
    if (n)
      var p = s ? n(_, v, f, e, t, a) : n(v, _, f, t, e, a);
    if (p !== void 0) {
      if (p)
        continue;
      l = !1;
      break;
    }
    if (h) {
      if (!nh(e, function(g, m) {
        if (!ua(h, m) && (v === g || o(v, g, r, n, a)))
          return h.push(m);
      })) {
        l = !1;
        break;
      }
    } else if (!(v === _ || o(v, _, r, n, a))) {
      l = !1;
      break;
    }
  }
  return a.delete(t), a.delete(e), l;
}
function sh(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n, o) {
    r[++e] = [o, n];
  }), r;
}
function Mr(t) {
  var e = -1, r = Array(t.size);
  return t.forEach(function(n) {
    r[++e] = n;
  }), r;
}
var ih = 1, ch = 2, uh = "[object Boolean]", lh = "[object Date]", fh = "[object Error]", dh = "[object Map]", ph = "[object Number]", hh = "[object RegExp]", gh = "[object Set]", vh = "[object String]", mh = "[object Symbol]", yh = "[object ArrayBuffer]", bh = "[object DataView]", Hn = J ? J.prototype : void 0, Fe = Hn ? Hn.valueOf : void 0;
function _h(t, e, r, n, o, a, s) {
  switch (r) {
    case bh:
      if (t.byteLength != e.byteLength || t.byteOffset != e.byteOffset)
        return !1;
      t = t.buffer, e = e.buffer;
    case yh:
      return !(t.byteLength != e.byteLength || !a(new be(t), new be(e)));
    case uh:
    case lh:
    case ph:
      return ie(+t, +e);
    case fh:
      return t.name == e.name && t.message == e.message;
    case hh:
    case vh:
      return t == e + "";
    case dh:
      var i = sh;
    case gh:
      var c = n & ih;
      if (i || (i = Mr), t.size != e.size && !c)
        return !1;
      var u = s.get(t);
      if (u)
        return u == e;
      n |= ch, s.set(t, e);
      var d = la(i(t), i(e), n, o, a, s);
      return s.delete(t), d;
    case mh:
      if (Fe)
        return Fe.call(t) == Fe.call(e);
  }
  return !1;
}
var Sh = 1, Oh = Object.prototype, Eh = Oh.hasOwnProperty;
function $h(t, e, r, n, o, a) {
  var s = r & Sh, i = Ze(t), c = i.length, u = Ze(e), d = u.length;
  if (c != d && !s)
    return !1;
  for (var f = c; f--; ) {
    var l = i[f];
    if (!(s ? l in e : Eh.call(e, l)))
      return !1;
  }
  var h = a.get(t), v = a.get(e);
  if (h && v)
    return h == e && v == t;
  var _ = !0;
  a.set(t, e), a.set(e, t);
  for (var p = s; ++f < c; ) {
    l = i[f];
    var g = t[l], m = e[l];
    if (n)
      var b = s ? n(m, g, l, e, t, a) : n(g, m, l, t, e, a);
    if (!(b === void 0 ? g === m || o(g, m, r, n, a) : b)) {
      _ = !1;
      break;
    }
    p || (p = l == "constructor");
  }
  if (_ && !p) {
    var y = t.constructor, S = e.constructor;
    y != S && "constructor" in t && "constructor" in e && !(typeof y == "function" && y instanceof y && typeof S == "function" && S instanceof S) && (_ = !1);
  }
  return a.delete(t), a.delete(e), _;
}
var wh = 1, Jn = "[object Arguments]", Wn = "[object Array]", fe = "[object Object]", Ch = Object.prototype, qn = Ch.hasOwnProperty;
function Nh(t, e, r, n, o, a) {
  var s = L(t), i = L(e), c = s ? Wn : W(t), u = i ? Wn : W(e);
  c = c == Jn ? fe : c, u = u == Jn ? fe : u;
  var d = c == fe, f = u == fe, l = c == u;
  if (l && Zt(t)) {
    if (!Zt(e))
      return !1;
    s = !0, d = !1;
  }
  if (l && !d)
    return a || (a = new q()), s || wr(t) ? la(t, e, r, n, o, a) : _h(t, e, c, r, n, o, a);
  if (!(r & wh)) {
    var h = d && qn.call(t, "__wrapped__"), v = f && qn.call(e, "__wrapped__");
    if (h || v) {
      var _ = h ? t.value() : t, p = v ? e.value() : e;
      return a || (a = new q()), o(_, p, r, n, a);
    }
  }
  return l ? (a || (a = new q()), $h(t, e, r, n, o, a)) : !1;
}
function Pr(t, e, r, n, o) {
  return t === e ? !0 : t == null || e == null || !Y(t) && !Y(e) ? t !== t && e !== e : Nh(t, e, r, n, Pr, o);
}
var jh = 1, xh = 2;
function Ah(t, e, r, n) {
  var o = r.length, a = o;
  if (t == null)
    return !a;
  for (t = Object(t); o--; ) {
    var s = r[o];
    if (s[2] ? s[1] !== t[s[0]] : !(s[0] in t))
      return !1;
  }
  for (; ++o < a; ) {
    s = r[o];
    var i = s[0], c = t[i], u = s[1];
    if (s[2]) {
      if (c === void 0 && !(i in t))
        return !1;
    } else {
      var d = new q(), f;
      if (!(f === void 0 ? Pr(u, c, jh | xh, n, d) : f))
        return !1;
    }
  }
  return !0;
}
function fa(t) {
  return t === t && !Q(t);
}
function Th(t) {
  for (var e = Ne(t), r = e.length; r--; ) {
    var n = e[r], o = t[n];
    e[r] = [n, o, fa(o)];
  }
  return e;
}
function da(t, e) {
  return function(r) {
    return r == null ? !1 : r[t] === e && (e !== void 0 || t in Object(r));
  };
}
function Rh(t) {
  var e = Th(t);
  return e.length == 1 && e[0][2] ? da(e[0][0], e[0][1]) : function(r) {
    return r === t || Ah(r, t, e);
  };
}
function Mh(t, e) {
  return t != null && e in Object(t);
}
function Ph(t, e, r) {
  e = Ut(e, t);
  for (var n = -1, o = e.length, a = !1; ++n < o; ) {
    var s = Bt(e[n]);
    if (!(a = t != null && r(t, s)))
      break;
    t = t[s];
  }
  return a || ++n != o ? a : (o = t == null ? 0 : t.length, !!o && Or(o) && we(s, o) && (L(t) || Xt(t)));
}
function Ih(t, e) {
  return t != null && Ph(t, e, Mh);
}
var Dh = 1, Lh = 2;
function Fh(t, e) {
  return Cr(t) && fa(e) ? da(Bt(t), e) : function(r) {
    var n = Ko(r, t);
    return n === void 0 && n === e ? Ih(r, t) : Pr(e, n, Dh | Lh);
  };
}
function Vh(t) {
  return function(e) {
    return e == null ? void 0 : e[t];
  };
}
function Uh(t) {
  return function(e) {
    return Ae(e, t);
  };
}
function Bh(t) {
  return Cr(t) ? Vh(Bt(t)) : Uh(t);
}
function Ir(t) {
  return typeof t == "function" ? t : t == null ? yr : typeof t == "object" ? L(t) ? Fh(t[0], t[1]) : Rh(t) : Bh(t);
}
function Gh(t) {
  return function(e, r, n) {
    for (var o = -1, a = Object(e), s = n(e), i = s.length; i--; ) {
      var c = s[++o];
      if (r(a[c], c, a) === !1)
        break;
    }
    return e;
  };
}
var zh = Gh();
function rr(t, e, r) {
  (r !== void 0 && !ie(t[e], r) || r === void 0 && !(e in t)) && _r(t, e, r);
}
function nr(t) {
  return Y(t) && Ce(t);
}
function or(t, e) {
  if (!(e === "constructor" && typeof t[e] == "function") && e != "__proto__")
    return t[e];
}
function kh(t) {
  return Vt(t, ce(t));
}
function Hh(t, e, r, n, o, a, s) {
  var i = or(t, r), c = or(e, r), u = s.get(c);
  if (u) {
    rr(t, r, u);
    return;
  }
  var d = a ? a(i, c, r + "", t, e, s) : void 0, f = d === void 0;
  if (f) {
    var l = L(c), h = !l && Zt(c), v = !l && !h && wr(c);
    d = c, l || h || v ? L(i) ? d = i : nr(i) ? d = Uo(i) : h ? (f = !1, d = Zo(c, !0)) : v ? (f = !1, d = na(c, !0)) : d = [] : B(c) || Xt(c) ? (d = i, Xt(i) ? d = kh(i) : (!Q(i) || br(i)) && (d = oa(c))) : f = !1;
  }
  f && (s.set(c, d), o(d, c, n, a, s), s.delete(c)), rr(t, r, d);
}
function pa(t, e, r, n, o) {
  t !== e && zh(e, function(a, s) {
    if (o || (o = new q()), Q(a))
      Hh(t, e, s, r, pa, n, o);
    else {
      var i = n ? n(or(t, s), a, s + "", t, e, o) : void 0;
      i === void 0 && (i = a), rr(t, s, i);
    }
  }, ce);
}
function ha(t) {
  var e = t == null ? 0 : t.length;
  return e ? t[e - 1] : void 0;
}
function Jh(t, e) {
  return e.length < 2 ? t : Ae(t, wd(e, 0, -1));
}
var ga = Jl(function(t, e, r) {
  pa(t, e, r);
}), Wh = "Expected a function";
function qh(t) {
  if (typeof t != "function")
    throw new TypeError(Wh);
  return function() {
    var e = arguments;
    switch (e.length) {
      case 0:
        return !t.call(this);
      case 1:
        return !t.call(this, e[0]);
      case 2:
        return !t.call(this, e[0], e[1]);
      case 3:
        return !t.call(this, e[0], e[1], e[2]);
    }
    return !t.apply(this, e);
  };
}
function Kh(t, e) {
  return e = Ut(e, t), t = Jh(t, e), t == null || delete t[Bt(ha(e))];
}
function Qh(t) {
  return B(t) ? void 0 : t;
}
var Yh = 1, Xh = 2, Zh = 4, va = bd(function(t, e) {
  var r = {};
  if (t == null)
    return r;
  var n = !1;
  e = mr(e, function(a) {
    return a = Ut(a, t), n || (n = a.length > 1), a;
  }), Vt(t, Tr(t), r), n && (r = qt(r, Yh | Xh | Zh, Qh));
  for (var o = e.length; o--; )
    Kh(r, e[o]);
  return r;
});
function tg(t, e, r, n) {
  if (!Q(t))
    return t;
  e = Ut(e, t);
  for (var o = -1, a = e.length, s = a - 1, i = t; i != null && ++o < a; ) {
    var c = Bt(e[o]), u = r;
    if (c === "__proto__" || c === "constructor" || c === "prototype")
      return t;
    if (o != s) {
      var d = i[c];
      u = void 0, u === void 0 && (u = Q(d) ? d : we(e[o + 1]) ? [] : {});
    }
    Sr(i, c, u), i = i[c];
  }
  return t;
}
function eg(t, e, r) {
  for (var n = -1, o = e.length, a = {}; ++n < o; ) {
    var s = e[n], i = Ae(t, s);
    r(i, s) && tg(a, Ut(s, t), i);
  }
  return a;
}
function rg(t, e) {
  if (t == null)
    return {};
  var r = mr(Tr(t), function(n) {
    return [n];
  });
  return e = Ir(e), eg(t, r, function(n, o) {
    return e(n, o[0]);
  });
}
function ng(t, e) {
  return rg(t, qh(Ir(e)));
}
var og = 1 / 0, ag = Tt && 1 / Mr(new Tt([, -0]))[1] == og ? function(t) {
  return new Tt(t);
} : Nl, sg = 200;
function ig(t, e, r) {
  var n = -1, o = Vl, a = t.length, s = !0, i = [], c = i;
  if (a >= sg) {
    var u = e ? null : ag(t);
    if (u)
      return Mr(u);
    s = !1, o = ua, c = new re();
  } else
    c = e ? [] : i;
  t:
    for (; ++n < a; ) {
      var d = t[n], f = e ? e(d) : d;
      if (d = d !== 0 ? d : 0, s && f === f) {
        for (var l = c.length; l--; )
          if (c[l] === f)
            continue t;
        e && c.push(f), i.push(d);
      } else o(c, f, r) || (c !== i && c.push(f), i.push(d));
    }
  return i;
}
var cg = zo(function(t) {
  var e = ha(t);
  return nr(e) && (e = void 0), ig(Qo(t, 1, nr, !0), Ir(e));
});
class ma extends TypeError {
  constructor(e, r) {
    let n;
    const {
      message: o,
      ...a
    } = e, {
      path: s
    } = e, i = s.length === 0 ? o : `At path: ${s.join(".")} -- ${o}`;
    super(i), this.value = void 0, this.key = void 0, this.type = void 0, this.refinement = void 0, this.path = void 0, this.branch = void 0, this.failures = void 0, Object.assign(this, a), this.name = this.constructor.name, this.failures = () => n ?? (n = [e, ...r()]);
  }
}
function ug(t) {
  return K(t) && typeof t[Symbol.iterator] == "function";
}
function K(t) {
  return typeof t == "object" && t != null;
}
function k(t) {
  return typeof t == "symbol" ? t.toString() : typeof t == "string" ? JSON.stringify(t) : `${t}`;
}
function lg(t) {
  const {
    done: e,
    value: r
  } = t.next();
  return e ? void 0 : r;
}
function fg(t, e, r, n) {
  if (t === !0)
    return;
  t === !1 ? t = {} : typeof t == "string" && (t = {
    message: t
  });
  const {
    path: o,
    branch: a
  } = e, {
    type: s
  } = r, {
    refinement: i,
    message: c = `Expected a value of type \`${s}\`${i ? ` with refinement \`${i}\`` : ""}, but received: \`${k(n)}\``
  } = t;
  return {
    value: n,
    type: s,
    refinement: i,
    key: o[o.length - 1],
    path: o,
    branch: a,
    ...t,
    message: c
  };
}
function* Kn(t, e, r, n) {
  ug(t) || (t = [t]);
  for (const o of t) {
    const a = fg(o, e, r, n);
    a && (yield a);
  }
}
function* Dr(t, e, r) {
  r === void 0 && (r = {});
  const {
    path: n = [],
    branch: o = [t],
    coerce: a = !1,
    mask: s = !1
  } = r, i = {
    path: n,
    branch: o
  };
  if (a && (t = e.coercer(t, i), s && e.type !== "type" && K(e.schema) && K(t) && !Array.isArray(t)))
    for (const u in t)
      e.schema[u] === void 0 && delete t[u];
  let c = "valid";
  for (const u of e.validator(t, i))
    c = "not_valid", yield [u, void 0];
  for (let [u, d, f] of e.entries(t, i)) {
    const l = Dr(d, f, {
      path: u === void 0 ? n : [...n, u],
      branch: u === void 0 ? o : [...o, d],
      coerce: a,
      mask: s
    });
    for (const h of l)
      h[0] ? (c = h[0].refinement != null ? "not_refined" : "not_valid", yield [h[0], void 0]) : a && (d = h[1], u === void 0 ? t = d : t instanceof Map ? t.set(u, d) : t instanceof Set ? t.add(d) : K(t) && (d !== void 0 || u in t) && (t[u] = d));
  }
  if (c !== "not_valid")
    for (const u of e.refiner(t, i))
      c = "not_refined", yield [u, void 0];
  c === "valid" && (yield [void 0, t]);
}
class tt {
  constructor(e) {
    this.TYPE = void 0, this.type = void 0, this.schema = void 0, this.coercer = void 0, this.validator = void 0, this.refiner = void 0, this.entries = void 0;
    const {
      type: r,
      schema: n,
      validator: o,
      refiner: a,
      coercer: s = (c) => c,
      entries: i = function* () {
      }
    } = e;
    this.type = r, this.schema = n, this.entries = i, this.coercer = s, o ? this.validator = (c, u) => {
      const d = o(c, u);
      return Kn(d, u, this, c);
    } : this.validator = () => [], a ? this.refiner = (c, u) => {
      const d = a(c, u);
      return Kn(d, u, this, c);
    } : this.refiner = () => [];
  }
  /**
   * Assert that a value passes the struct's validation, throwing if it doesn't.
   */
  assert(e) {
    return ya(e, this);
  }
  /**
   * Create a value with the struct's coercion logic, then validate it.
   */
  create(e) {
    return dg(e, this);
  }
  /**
   * Check if a value passes the struct's validation.
   */
  is(e) {
    return hg(e, this);
  }
  /**
   * Mask a value, coercing and validating it, but returning only the subset of
   * properties defined by the struct's schema.
   */
  mask(e) {
    return pg(e, this);
  }
  /**
   * Validate a value with the struct's validation logic, returning a tuple
   * representing the result.
   *
   * You may optionally pass `true` for the `withCoercion` argument to coerce
   * the value before attempting to validate it. If you do, the result will
   * contain the coerced result when successful.
   */
  validate(e, r) {
    return r === void 0 && (r = {}), Gt(e, this, r);
  }
}
function ya(t, e) {
  const r = Gt(t, e);
  if (r[0])
    throw r[0];
}
function dg(t, e) {
  const r = Gt(t, e, {
    coerce: !0
  });
  if (r[0])
    throw r[0];
  return r[1];
}
function pg(t, e) {
  const r = Gt(t, e, {
    coerce: !0,
    mask: !0
  });
  if (r[0])
    throw r[0];
  return r[1];
}
function hg(t, e) {
  return !Gt(t, e)[0];
}
function Gt(t, e, r) {
  r === void 0 && (r = {});
  const n = Dr(t, e, r), o = lg(n);
  return o[0] ? [new ma(o[0], function* () {
    for (const a of n)
      a[0] && (yield a[0]);
  }), void 0] : [void 0, o[1]];
}
function Lr() {
  for (var t = arguments.length, e = new Array(t), r = 0; r < t; r++)
    e[r] = arguments[r];
  const n = e[0].type === "type", o = e.map((s) => s.schema), a = Object.assign({}, ...o);
  return n ? Oa(a) : A(a);
}
function pt(t, e) {
  return new tt({
    type: t,
    schema: null,
    validator: e
  });
}
function Pt(t) {
  return new tt({
    type: "dynamic",
    schema: null,
    *entries(e, r) {
      yield* t(e, r).entries(e, r);
    },
    validator(e, r) {
      return t(e, r).validator(e, r);
    },
    coercer(e, r) {
      return t(e, r).coercer(e, r);
    },
    refiner(e, r) {
      return t(e, r).refiner(e, r);
    }
  });
}
function ba(t, e) {
  const {
    schema: r
  } = t, n = {
    ...r
  };
  for (const o of e)
    delete n[o];
  switch (t.type) {
    case "type":
      return Oa(n);
    default:
      return A(n);
  }
}
function T() {
  return pt("any", () => !0);
}
function I(t) {
  return new tt({
    type: "array",
    schema: t,
    *entries(e) {
      if (t && Array.isArray(e))
        for (const [r, n] of e.entries())
          yield [r, n, t];
    },
    coercer(e) {
      return Array.isArray(e) ? e.slice() : e;
    },
    validator(e) {
      return Array.isArray(e) || `Expected an array value, but received: ${k(e)}`;
    }
  });
}
function St() {
  return pt("boolean", (t) => typeof t == "boolean");
}
function ar(t) {
  const e = {}, r = t.map((n) => k(n)).join();
  for (const n of t)
    e[n] = n;
  return new tt({
    type: "enums",
    schema: e,
    validator(n) {
      return t.includes(n) || `Expected one of \`${r}\`, but received: ${k(n)}`;
    }
  });
}
function _a() {
  return pt("func", (t) => typeof t == "function" || `Expected a function, but received: ${k(t)}`);
}
function G(t) {
  const e = k(t), r = typeof t;
  return new tt({
    type: "literal",
    schema: r === "string" || r === "number" || r === "boolean" ? t : null,
    validator(n) {
      return n === t || `Expected the literal \`${e}\`, but received: ${k(n)}`;
    }
  });
}
function gg() {
  return pt("never", () => !1);
}
function Sa() {
  return pt("number", (t) => typeof t == "number" && !isNaN(t) || `Expected a number, but received: ${k(t)}`);
}
function A(t) {
  const e = t ? Object.keys(t) : [], r = gg();
  return new tt({
    type: "object",
    schema: t || null,
    *entries(n) {
      if (t && K(n)) {
        const o = new Set(Object.keys(n));
        for (const a of e)
          o.delete(a), yield [a, n[a], t[a]];
        for (const a of o)
          yield [a, n[a], r];
      }
    },
    validator(n) {
      return K(n) || `Expected an object, but received: ${k(n)}`;
    },
    coercer(n) {
      return K(n) ? {
        ...n
      } : n;
    }
  });
}
function O(t) {
  return new tt({
    ...t,
    validator: (e, r) => e === void 0 || t.validator(e, r),
    refiner: (e, r) => e === void 0 || t.refiner(e, r)
  });
}
function Kt(t, e) {
  return new tt({
    type: "record",
    schema: null,
    *entries(r) {
      if (K(r))
        for (const n in r) {
          const o = r[n];
          yield [n, n, t], yield [n, o, e];
        }
    },
    validator(r) {
      return K(r) || `Expected an object, but received: ${k(r)}`;
    }
  });
}
function E() {
  return pt("string", (t) => typeof t == "string" || `Expected a string, but received: ${k(t)}`);
}
function Oa(t) {
  const e = Object.keys(t);
  return new tt({
    type: "type",
    schema: t,
    *entries(r) {
      if (K(r))
        for (const n of e)
          yield [n, r[n], t[n]];
    },
    validator(r) {
      return K(r) || `Expected an object, but received: ${k(r)}`;
    }
  });
}
function z(t) {
  const e = t.map((r) => r.type).join(" | ");
  return new tt({
    type: "union",
    schema: null,
    coercer(r, n) {
      return (t.find((o) => {
        const [a] = o.validate(r, {
          coerce: !0
        });
        return !a;
      }) || vg()).coercer(r, n);
    },
    validator(r, n) {
      const o = [];
      for (const a of t) {
        const [...s] = Dr(r, a, n), [i] = s;
        if (i[0])
          for (const [c] of s)
            c && o.push(c);
        else
          return [];
      }
      return [`Expected the value to satisfy a union of \`${e}\`, but received: ${k(r)}`, ...o];
    }
  });
}
function vg() {
  return pt("unknown", () => !0);
}
const Fr = A({
  package: E(),
  version: E(),
  name: E(),
  exportName: O(E()),
  destructuring: O(St()),
  subName: O(E()),
  main: O(E()),
  cssPaths: O(I(E()))
}), mg = I(Fr);
var U = /* @__PURE__ */ ((t) => (t.SLOT = "SLOT", t.FUNCTION = "FUNCTION", t.EXPRESSION = "EXPRESSION", t.ACTION = "ACTION", t.EVENT = "EVENT", t))(U || {}), Vr = /* @__PURE__ */ ((t) => (t.DESIGN = "design", t.SAVE = "save", t))(Vr || {}), sr = /* @__PURE__ */ ((t) => (t.FUNC = "FUNC", t.COMP = "COMP", t))(sr || {});
const yg = () => pt("normalObj", (t) => !B(t) || [U.SLOT, U.EXPRESSION, U.FUNCTION].includes(t == null ? void 0 : t.type) ? !1 : (Gt(t, Kt(E(), Ur)), !0)), Ur = z([
  E(),
  Sa(),
  St(),
  A({
    type: G(U.SLOT),
    renderType: ar([sr.FUNC, sr.COMP]),
    // if renderType is Func， params will be useful
    params: O(I(E())),
    // here can't use PropsDataStructDescribe, it will  caused  "Maximum call stack size exceeded" error
    value: Pt(() => z([It, I(It)]))
  }),
  A({
    type: G(U.EXPRESSION),
    value: E()
  }),
  A({
    type: G(U.FUNCTION),
    value: E()
  }),
  A({
    type: G(U.ACTION),
    /** 暂时不做规则强检验 */
    handler: T()
  }),
  yg(),
  I(
    Pt(() => Ur)
  )
]);
var Ea = /* @__PURE__ */ ((t) => (t.COMPONENTS = "COMPONENTS", t))(Ea || {});
const Qn = A({
  type: G(U.EXPRESSION),
  value: E()
}), It = A({
  id: O(E()),
  title: O(E()),
  componentName: E(),
  props: O(Kt(E(), Ur)),
  nodeName: O(E()),
  state: O(Kt(E(), T())),
  children: Pt(() => O(I(z([E(), It])))),
  eventListener: O(I(T())),
  configure: O(T()),
  css: O(T()),
  style: O(T()),
  classNames: O(I(T())),
  refId: O(E()),
  extra: O(Kt(T(), T())),
  condition: O(z([St(), Qn])),
  loop: O(
    A({
      open: St(),
      data: z([I(T()), Qn]),
      args: O(I(E())),
      forName: O(E()),
      forIndex: O(E()),
      key: O(T()),
      name: O(E())
    })
  ),
  injectEnvList: O(I(T())),
  methods: O(I(T()))
}), _e = z([
  E(),
  A({
    label: E(),
    tip: O(E())
  })
]), bg = A({
  type: G(
    "shape"
    /* SHAPE */
  ),
  value: I(
    A({
      name: E(),
      title: _e,
      valueType: Pt(() => Te)
    })
  )
}), _g = A({
  type: G(
    "enums"
    /* ENUMS */
  ),
  value: I(E())
});
A({
  type: G(
    "array"
    /* ARRAY */
  ),
  value: Pt(() => Te)
});
const Sg = A({
  type: G(
    "array"
    /* ARRAY */
  ),
  value: Pt(() => I(Te))
}), Te = z([
  ar([
    "array",
    "boolean",
    "number",
    "object",
    "string"
    /* STRING */
  ]),
  ar([
    "component",
    "expression",
    "function"
    /* FUNCTION */
  ]),
  bg,
  _g,
  Sg
]), Og = z([
  E(),
  A({
    componentName: E(),
    props: O(T()),
    /** 用于标记当前数据的初始值，如添加一个数组元素可以使用该值填充 */
    initialValue: O(T()),
    component: O(T()),
    hiddenLabel: O(St())
  })
]), Ve = A({
  name: E(),
  title: _e,
  // 描述 name 对应值的类型
  valueType: Te,
  description: O(E()),
  defaultValue: T(),
  //用于产生 valueType 类型的值
  setters: O(I(Og)),
  condition: O(_a())
});
z([E(), _a()]);
var ir = /* @__PURE__ */ ((t) => (t.SINGLE = "single", t.GROUP = "group", t))(ir || {});
z([
  E(),
  A({
    event: E(),
    name: O(E()),
    describe: O(E()),
    params: O(
      I(
        A({
          name: E(),
          description: E(),
          example: E()
        })
      )
    ),
    template: O(E())
  })
]);
const Eg = A({
  id: O(E()),
  title: E(),
  snapshot: z([E(), T()]),
  snapshotText: O(E()),
  description: O(E()),
  // 组件分类,用于搜索
  tags: O(I(E())),
  // 分 tab 面板
  groupName: O(E()),
  // 分类
  category: O(E()),
  schema: Lr(ba(It, ["id"]), A({ componentName: O(E()) }))
}), $g = A({
  componentName: E(),
  title: E(),
  screenshot: O(E()),
  icon: O(E()),
  // 组件分类,用于搜索
  tags: O(I(E())),
  // 分 tab 面板
  groupName: O(E()),
  // 分类
  category: O(E()),
  // 排序
  priority: O(Sa()),
  npm: O(Fr),
  snippets: I(Eg),
  props: I(
    z([
      Ve,
      A({
        title: O(_e),
        type: G(
          "single"
          /* SINGLE */
        ),
        content: Ve
      }),
      A({
        title: O(_e),
        type: G(
          "group"
          /* GROUP */
        ),
        content: I(Ve)
      })
    ])
  ),
  events: O(T()),
  methods: O(T()),
  fixedProps: O(T()),
  // 可以拖入组件
  isContainer: O(
    z([
      St(),
      A({
        placeholder: E(),
        width: E(),
        height: E()
      })
    ])
  ),
  disableEditorDragDom: O(T()),
  // 如果是布局组件，可以考虑将拖拽控制权转移 or 实现 resize
  isLayout: O(St()),
  rootSelector: O(E()),
  // selectionToolBarView: optional(func()),
  advanceCustom: O(T()),
  // 扩展配置
  extra: O(Kt(T(), T()))
}), wg = (t) => ({ data: e, message: r, throwError: n }) => {
  const o = t({ data: e, message: r, throwError: n });
  if (o.isValidate)
    return o;
  if (n)
    throw o.message || r ? new Error(`${o.message || r}
 originData: ${JSON.stringify(e)}`) : new Error(`${JSON.stringify(e)} 
 data struct format is invalidate`);
  return o.message || r ? console.warn(`${o.message || r}
 originData: ${JSON.stringify(e)}`) : console.warn(`${JSON.stringify(e)} 
 data struct format is invalidate`), o;
}, Br = (t) => {
  const { data: e, message: r, throwError: n, dataStruct: o } = t;
  return wg(({ data: a }) => {
    try {
      return ya(a, o), {
        isValidate: !0
      };
    } catch (s) {
      let i = s;
      return s instanceof ma && (i = s.failures().map((c) => `【${c.path.join(".")}】: ${c.message}
`)), {
        isValidate: !1,
        message: i,
        error: s
      };
    }
  })({ data: e, message: r, throwError: n });
};
var rt = /* @__PURE__ */ ((t) => (t.ROOT_CONTAINER = "RootContainer", t))(rt || {});
const Cg = A({
  type: G(U.FUNCTION),
  value: E()
}), Ng = Lr(
  ba(It, ["componentName"]),
  A({
    componentName: G(
      "RootContainer"
      /* ROOT_CONTAINER */
    )
  })
);
function jg(t) {
  return { all: t = t || /* @__PURE__ */ new Map(), on: function(e, r) {
    var n = t.get(e);
    n ? n.push(r) : t.set(e, [r]);
  }, off: function(e, r) {
    var n = t.get(e);
    n && (r ? n.splice(n.indexOf(r) >>> 0, 1) : t.set(e, []));
  }, emit: function(e, r) {
    var n = t.get(e);
    n && n.slice().map(function(o) {
      o(r);
    }), (n = t.get("*")) && n.slice().map(function(o) {
      o(e, r);
    });
  } };
}
const ue = jg(), xg = (t, e) => {
  const r = {
    ...t,
    value: []
  }, n = t.value;
  let o = new Lt([]);
  return e && (o = e.materialsMode || new Lt([])), n && (L(n) ? r.value = n.map(
    (a) => new D(a, {
      parent: e,
      materials: o
    })
  ) : B(n) && r.value.push(
    new D(n, {
      parent: e,
      materials: o
    })
  )), r;
};
class Dt {
  constructor(e, r) {
    C(this, "nodeType", "SLOT"), C(this, "rawData"), C(this, "parent"), C(this, "emitter", ue), C(this, "data"), C(this, "id"), C(this, "materialsMode"), this.parent = (r == null ? void 0 : r.parent) || null, this.rawData = e;
    const n = (r == null ? void 0 : r.materials) || new Lt([]);
    this.materialsMode = n, this.id = et(), this.data = xg(e, this);
  }
  get value() {
    return this.data;
  }
  export(e) {
    const r = this.data, n = (o) => {
      if (o instanceof D)
        return o.export(e);
      if (B(o)) {
        const a = {};
        return Object.keys(o || {}).forEach((s) => {
          a[s] = n(o[s]);
        }), a;
      }
      return L(o) ? o.map((a) => n(a)) : (e === "design" && delete o.id, o);
    };
    return n(r);
  }
}
const $a = (t) => {
  let e = [];
  return t.forEach((r) => {
    const n = r;
    n.type ? n.type === ir.SINGLE ? e.push(n.content) : n.type === ir.GROUP && (e = [...e, ...$a(n.content)]) : e.push(r);
  }), e;
}, cr = (t, e, r) => {
  if (t.type)
    return t.type === U.SLOT ? new Dt(t, { parent: e, materials: r }) : t;
  if (B(t)) {
    const n = {};
    return Object.keys(t).forEach((o) => {
      n[o] = ur(t[o], e, r);
    }), n;
  } else return Array.isArray(t) ? t.map((n) => cr(n, e, r)) : t;
}, ur = (t, e, r) => B(t) ? cr(t, e, r) : L(t) ? t.map((n) => cr(n, e, r)) : t;
class dt {
  constructor(e, r, n) {
    C(this, "nodeType", "PROP"), C(this, "rawData"), C(this, "parent"), C(this, "emitter", ue), C(this, "data"), C(this, "name"), C(this, "materialsMode");
    const o = (n == null ? void 0 : n.materials) || new Lt([]);
    this.materialsMode = o, this.parent = n == null ? void 0 : n.parent, this.rawData = r, this.name = e, this.data = ur(r, this, o);
  }
  // TODO:
  isIncludeSlot() {
    return !1;
  }
  // TODO:
  isIncludeExpression() {
    return !1;
  }
  get value() {
    return this.data;
  }
  updateValue(e) {
    const r = this.data;
    this.data = ur(e ?? r, this, this.materialsMode), this.emitter.emit("onPropChange", {
      value: this.data,
      preValue: r,
      node: this
    }), this.parent && !(this.parent instanceof Dt) && this.emitter.emit("onNodeChange", {
      value: this.parent.value,
      preValue: this.parent.value,
      node: this.parent
    });
  }
  get material() {
    const e = this.parent;
    if (e instanceof D) {
      const r = e.material;
      return $a((r == null ? void 0 : r.value.props) || []).find((n) => n.name === this.name);
    } else
      return null;
  }
  export(e) {
    const r = this.data, n = (o) => {
      if (o instanceof dt || o instanceof Dt || o instanceof D)
        return o.export(e);
      if (L(o))
        return o.map((a) => n(a));
      if (B(o)) {
        const a = {};
        return Object.keys(o || {}).forEach((s) => {
          a[s] = n(o[s]);
        }), a;
      }
      return o;
    };
    return n(r);
  }
}
const Ag = (t) => {
  if (typeof t == "string")
    return !0;
  Br({
    data: t,
    dataStruct: It,
    throwError: !1
  });
}, Yn = (t, e, r) => {
  if (typeof t == "string")
    return t;
  const n = {
    ...t,
    id: t.id ?? et(),
    children: [],
    props: {},
    methods: t.methods || [],
    configure: ga(t.configure || {}, {
      propsSetter: {},
      advanceSetter: {}
    })
  }, o = Object.keys(t.props || {});
  return o.length && o.forEach((a) => {
    var s;
    const i = (s = t.props) == null ? void 0 : s[a];
    if (i instanceof dt) {
      n.props[a] = i;
      return;
    }
    n.props[a] = new dt(a, i, {
      parent: e,
      materials: r
    });
  }), t.children && (Array.isArray(t.children) ? n.children = t.children.map((a) => {
    if (a instanceof D)
      return a;
    if (B(a)) {
      const s = a;
      return new D(s, {
        parent: e,
        materials: r
      });
    } else
      return a;
  }) : (t.children instanceof D && (n.children = [t.children]), n.children = [
    new D(t.children, {
      parent: e,
      materials: r
    })
  ])), n;
};
class D {
  constructor(e, r) {
    C(this, "nodeType", "NODE"), C(this, "rawData"), C(this, "data"), C(this, "emitter", ue), C(this, "parent"), C(this, "materialsModel"), C(this, "listenerHandler"), C(this, "onChangeCbQueue"), this.rawData = JSON.parse(JSON.stringify(e)), Ag(e);
    const n = (r == null ? void 0 : r.materials) || new Lt([]);
    this.parent = (r == null ? void 0 : r.parent) || null, this.materialsModel = n, this.data = Yn(e, this, n), this.listenerHandler = [], this.onChangeCbQueue = [], this.registerListener();
  }
  registerListener() {
    const e = (r) => {
      const { node: n } = r;
      n === this && n.id === this.id && this.onChangeCbQueue.forEach((o) => o(r));
    };
    this.emitter.on("onNodeChange", e), this.listenerHandler.push(() => {
      this.emitter.off("onNodeChange", e);
    });
  }
  onChange(e) {
    return this.onChangeCbQueue.push(e), () => {
      this.onChangeCbQueue = this.onChangeCbQueue.filter((r) => r !== e);
    };
  }
  destroy() {
    this.listenerHandler.forEach((e) => e());
  }
  get id() {
    return this.data.id;
  }
  get value() {
    return this.data;
  }
  clone(e) {
    const r = {
      ...this.export("design"),
      id: e || et()
    };
    return new D(r, {
      materials: this.materialsModel
    });
  }
  updateWithPlainObj(e) {
    const r = {
      ...this.data,
      ...e
    };
    return this.data = Yn(r, this, this.materialsModel), r;
  }
  updateValue(e) {
    const r = this.data, n = this.updateWithPlainObj(e);
    this.emitter.emit("onNodeChange", {
      value: n,
      preValue: r,
      node: this
    });
  }
  contains(e) {
    return zr(this, e);
  }
  get props() {
    return this.data.props;
  }
  get material() {
    const e = this.materialsModel;
    return e == null ? void 0 : e.findByComponentName(this.data.componentName);
  }
  getPlainProps() {
    const e = this.data, r = {};
    return Object.keys(e.props || {}).forEach((n) => {
      r[n] = e.props[n].export("design");
    }), r;
  }
  // 节点物料中的配置信息
  getMaterialConfig(e) {
    var r;
    return this.data.configure[e] !== void 0 ? this.data.configure.isContainer : (r = this.material) == null ? void 0 : r.value.isContainer;
  }
  isContainer() {
    return this.getMaterialConfig("isContainer");
  }
  export(e) {
    var r;
    const n = this.data;
    if (typeof n == "string")
      return n;
    const o = {};
    Object.keys(n.props || {}).forEach((f) => {
      o[f] = n.props[f].export(e);
    });
    const a = (r = n.children) == null ? void 0 : r.map((f) => f instanceof D ? f.export(e) : f), s = n.configure || {}, i = s.propsSetter || {}, c = {};
    Object.keys(i).forEach((f) => {
      const l = Ko(i, f, !1);
      l && (c[f] = l);
    }), s.propsSetter = c;
    const u = this.materialsModel.usedMaterials.find(
      (f) => {
        var l;
        return f.componentName === ((l = this.material) == null ? void 0 : l.componentName);
      }
    );
    this.material && !u && this.materialsModel.usedMaterials.push(this.material);
    let d = {
      ...n,
      configure: s,
      props: o,
      children: a,
      condition: n.condition,
      extra: this.data.extra
    };
    return e === "design" && delete d.id, d = Gr(d), d;
  }
}
const Xn = (t, e, r) => {
  const n = {
    ...t,
    id: et(),
    props: {},
    componentName: rt.ROOT_CONTAINER,
    children: [],
    methods: t.methods || [],
    configure: ga(t.configure || {}, {
      propsSetter: {},
      advanceSetter: {}
    }),
    /** 需要注入给特定组件的运行时引擎的内置变量 */
    injectEnvList: t.injectEnvList
  };
  let o = [];
  L(t.children) ? o = t.children.map((s) => s instanceof D ? s : B(s) ? new D(s, { parent: e, materials: r }) : s) : t.children instanceof D ? o.push(t.children) : t.children && B(t.children) && o.push(new D(t.children, { parent: e, materials: r }));
  const a = Object.keys(t.props || {});
  return a.length && a.forEach((s) => {
    var i;
    const c = (i = t.props) == null ? void 0 : i[s];
    c instanceof dt ? n.props[s] = c : n.props[s] = new dt(s, c || "", {
      parent: e,
      materials: r
    });
  }), n.children = o, n;
};
class ne {
  constructor(e, { parent: r, materials: n }) {
    C(this, "rawData"), C(this, "data"), C(this, "nodeType", rt.ROOT_CONTAINER), C(this, "emitter", ue), C(this, "materialsModel"), C(this, "listenerHandler"), C(this, "onChangeCbQueue"), C(this, "parent"), this.materialsModel = n, this.rawData = JSON.parse(JSON.stringify(e)), this.data = Xn(e, this, n), this.listenerHandler = [], this.onChangeCbQueue = [], this.registerListener(), this.parent = r;
  }
  registerListener() {
    const e = (r) => {
      const { node: n } = r;
      n === this && n.id === this.id && this.onChangeCbQueue.forEach((o) => o(r));
    };
    this.emitter.on("onNodeChange", e), this.listenerHandler.push(() => {
      this.emitter.off("onNodeChange", e);
    });
  }
  onChange(e) {
    return this.onChangeCbQueue.push(e), () => {
      this.onChangeCbQueue = this.onChangeCbQueue.filter((r) => r !== e);
    };
  }
  get id() {
    return this.data.id;
  }
  get value() {
    return this.data;
  }
  get props() {
    return this.data.props;
  }
  get material() {
    const e = this.materialsModel;
    return e == null ? void 0 : e.findByComponentName(this.data.componentName);
  }
  updateWithPlainObj(e) {
    const r = {
      ...this.data,
      ...e
    };
    return this.data = Xn(r, this, this.materialsModel), r;
  }
  updateValue(e) {
    const r = this.data;
    this.updateWithPlainObj(e), this.emitter.emit("onNodeChange", {
      value: this.data,
      preValue: r,
      node: this
    });
  }
  contains(e) {
    return zr(this, e);
  }
  /**
   * 从物料 和 node config 中获取合并后的属性，node 中的配置优先级更高
   * @param key 目前只支持 isContainer 属性
   * @returns
   */
  getMaterialConfig(e) {
    var r;
    return this.data.configure[e] !== void 0 ? this.data.configure.isContainer : (r = this.material) == null ? void 0 : r.value.isContainer;
  }
  isContainer() {
    return this.getMaterialConfig("isContainer");
  }
  export(e = Vr.SAVE) {
    var r;
    const n = this.data, o = {};
    Object.keys(n.props || {}).forEach((c) => {
      o[c] = n.props[c].export(e);
    });
    const a = ((r = n.children) == null ? void 0 : r.map((c) => {
      var u;
      return (u = c == null ? void 0 : c.export) == null ? void 0 : u.call(c, e);
    })) || [], s = {
      ...n,
      props: o,
      children: a.filter((c) => c),
      condition: n.condition,
      extra: this.data.extra
    };
    let i = va(s, ["id"]);
    return i = Gr(i), i;
  }
  getPlainProps() {
    const e = this.data, r = {};
    return Object.keys(e.props || {}).forEach((n) => {
      r[n] = e.props[n].export("design");
    }), r;
  }
  destroy() {
    this.listenerHandler.forEach((e) => e());
  }
  clone(e) {
    const r = {
      ...this.export("design"),
      id: e || et()
    };
    return new ne(r, {
      materials: this.materialsModel,
      parent: null
    });
  }
}
const mt = (t) => (t == null ? void 0 : t.type) === U.EXPRESSION, wa = (t) => (t == null ? void 0 : t.type) === U.FUNCTION, Tg = (t) => (t == null ? void 0 : t.type) === U.ACTION, et = () => Math.random().toString(32).slice(3, 9), Rg = (t) => (t == null ? void 0 : t.nodeType) === "NODE", lr = (t) => (t == null ? void 0 : t.nodeType) === "PROP", Mg = (t) => (t == null ? void 0 : t.nodeType) === "SLOT", Gr = (t) => ng(t, (e) => B(e) ? !Object.keys(e).length : L(e) ? !e.length : e == null);
function Pg(t, e) {
  const r = [t];
  for (; r.length; ) {
    const n = r.shift();
    if (n && e(n))
      return n;
    const o = (n == null ? void 0 : n.props) || {}, a = (i) => {
      if (i instanceof D) {
        r.push(i);
        return;
      }
      if (i instanceof Dt && a(i.value.value), i instanceof dt) {
        a(i.value);
        return;
      }
      if (B(i)) {
        const c = i;
        Object.keys(c).forEach((u) => {
          a(c[u]);
        });
        return;
      }
      if (L(i)) {
        i.forEach((c) => {
          a(c);
        });
        return;
      }
    };
    a(o);
    const s = (n == null ? void 0 : n.value.children.filter((i) => i instanceof D)) || [];
    r.push(...s);
  }
}
function zr(t, e) {
  return Pg(t, (r) => r.id === e);
}
const Ig = (t) => {
  const e = ca(t), r = e.snippets;
  return delete e.snippets, e.snippets = r.map((n) => ({
    ...e,
    ...n,
    id: n.id || `${t.componentName}-${et()}`,
    title: n.title || t.title,
    category: n.category || t.category,
    tags: [...n.tags || [], ...t.tags || []],
    groupName: n.groupName || t.groupName,
    snapshot: n.snapshot || t.icon,
    snapshotText: n.snapshotText,
    schema: {
      ...n.schema,
      componentName: n.schema.componentName || t.componentName
    }
  })), e;
};
class Dg {
  constructor(e) {
    C(this, "rawData"), C(this, "data"), this.rawData = e, this.data = Ig(e);
  }
  get value() {
    return this.data;
  }
  get rawValue() {
    return this.rawData;
  }
  get componentName() {
    return this.data.componentName;
  }
  get snippets() {
    return this.data.snippets;
  }
  getSnippetById(e) {
    return this.data.snippets.find((r) => r.id === e);
  }
}
const Ue = (t) => {
  if (!L(t))
    throw new Error("Materials must be a array");
  return t.map((e) => new Dg(e));
}, Lg = (t) => {
  t == null || t.forEach((e) => {
    Br({
      data: e,
      dataStruct: $g,
      throwError: !1
    });
  });
};
class Lt {
  constructor(e) {
    C(this, "rawData"), C(this, "data"), C(this, "usedMaterials", []), this.rawData = e, Lg(e), this.data = Ue(e);
  }
  addMaterials(e) {
    const r = Ue(e), n = [], o = this.data.map((s) => {
      const i = r.findIndex((c) => c.componentName === s.componentName);
      return i >= 0 ? (n.push(i), r[i]) : s;
    }), a = r.filter((s, i) => !n.includes(i));
    this.data = [...o, ...a];
  }
  // 使用新的物料整个替换现有的物料列表
  replaceMaterials(e) {
    const r = Ue(e);
    this.data = [...r];
  }
  removeMaterial(e) {
    const r = this.data.filter((n) => !e.includes(n.componentName));
    this.data = r;
  }
  findByComponentName(e) {
    return this.data.find((r) => r.componentName === e);
  }
  findSnippetById(e) {
    const r = [...this.data];
    let n = null;
    for (; !n && r.length; ) {
      const o = r.pop();
      n = o == null ? void 0 : o.getSnippetById(e);
    }
    return n;
  }
  getAllSnippets() {
    const e = this.data.reduce((a, s) => (a.push(...s.snippets), a), []), r = [], n = {
      default: []
    };
    e.forEach((a) => {
      const s = a.groupName || "default";
      r.includes(s) || (r.push(s), n[s] = []), n[s].push(a);
    });
    let o = [];
    return r.forEach((a) => {
      const s = ["default"], i = {
        default: []
      }, c = n[a];
      if (c.length !== 0) {
        c.forEach((f) => {
          const l = f.category || "default";
          s.includes(l) || (s.push(l), i[l] = []), i[l].push(f);
        });
        const u = [];
        s.forEach((f) => {
          i[f].length && u.push({
            name: f,
            list: i[f]
          });
        });
        const d = {
          name: a,
          list: u
        };
        o.push(d);
      }
    }), o = o.sort((a, s) => (a.name || "") > (s.name || "") ? 1 : -1), o;
  }
  get value() {
    return this.data;
  }
  get rawValue() {
    return this.rawData;
  }
}
const Fg = A({
  version: O(E()),
  name: O(E()),
  css: O(E()),
  lifecycle: O(T()),
  props: O(T()),
  methods: O(I(Cg)),
  componentsMeta: I(
    Lr(
      A({
        componentName: E()
      }),
      Fr
    )
  ),
  thirdLibs: O(mg),
  componentsTree: Ng,
  assets: O(I(T())),
  extra: O(T())
}), Ca = (t) => (Br({
  data: t,
  dataStruct: Fg,
  throwError: !1
}), t), Be = (t, e, r) => ({
  ...t,
  componentsTree: new ne(t.componentsTree, {
    parent: e,
    materials: r
  })
});
class Se {
  constructor(e, r) {
    C(this, "nodeType", "PAGE"), C(this, "rawData"), C(this, "emitter", ue), C(this, "data"), C(this, "parent"), C(this, "materialsModel"), C(this, "assetPackagesList"), Ca(e), this.rawData = JSON.parse(JSON.stringify(e)), this.materialsModel = new Lt((r == null ? void 0 : r.materials) || []), this.data = Be(e, this, this.materialsModel), this.assetPackagesList = [...(r == null ? void 0 : r.assetPackagesList) || [], ...this.data.assets || []];
  }
  updatePage(e) {
    const r = this.data;
    this.rawData = JSON.parse(JSON.stringify(e)), this.data = Be(e, this, this.materialsModel), this.emitter.emit("onPageChange", {
      value: this.data,
      preValue: r,
      node: this
    });
  }
  reloadPage(e) {
    const r = this.data;
    e && (this.rawData = JSON.parse(JSON.stringify(e)), this.data = Be(e, this, this.materialsModel)), this.emitter.emit("onReloadPage", {
      value: this.data,
      preValue: r,
      node: this
    });
  }
  get value() {
    return this.data;
  }
  // moveNode(from, to, pos) {}
  getNode(e) {
    if (!e) return;
    const r = this.data.componentsTree;
    return zr(r, e);
  }
  addNode(e, r, n = "AFTER") {
    var o;
    if (n === "AFTER" || n === "BEFORE") {
      const a = r.parent;
      if (a === null && r instanceof ne)
        return console.warn("Not found parent node"), !1;
      if (a instanceof dt)
        return console.warn("CProp can not add node"), !1;
      if (a instanceof Dt) {
        const i = a.value.value, c = i.findIndex((u) => u === r) ?? -1;
        return c >= 0 ? (n === "BEFORE" ? i.splice(c, 0, e) : i.splice(c + 1, 0, e), e.parent = a, (o = a.parent) == null || o.updateValue(), !0) : !1;
      }
      if (a instanceof Se)
        return !1;
      const s = (a == null ? void 0 : a.value.children.findIndex((i) => i === r)) ?? -1;
      return s >= 0 ? (n === "BEFORE" ? a == null || a.value.children.splice(s, 0, e) : a == null || a.value.children.splice(s + 1, 0, e), e.parent = a, a == null || a.updateValue(), !0) : (console.warn("Not found target node"), !1);
    }
    if (n === "CHILD_START")
      return r.value.children.unshift(e), e.parent = r, r.updateValue(), !0;
    if (n === "CHILD_END")
      return r.value.children.push(e), e.parent = r, r.updateValue(), !0;
    if (B(n)) {
      const a = n;
      if (a.type === "CHILD") {
        const s = a.pos, i = a.index || 0;
        return s === "BEFORE" ? r == null || r.value.children.splice(i, 0, e) : r == null || r.value.children.splice(i + 1, 0, e), e.parent = r, r.updateValue(), !0;
      } else
        console.warn("Can not parse pos obj");
    }
    return !1;
  }
  createNode(e) {
    return delete e.id, new D(e, {
      parent: null,
      materials: this.materialsModel
    });
  }
  addNodeById(e, r, n = "AFTER") {
    const o = this.getNode(r);
    return o ? this.addNode(e, o, n) : (console.warn(`Not find a node by ${r}, pls check it`), !1);
  }
  copyNode(e) {
    const r = e.export("design");
    r.id = et();
    const n = new D(r, {
      parent: e.parent,
      materials: this.materialsModel
    });
    return this.addNode(n, e, "AFTER"), n;
  }
  copyNodeById(e) {
    const r = this.getNode(e);
    return r && r instanceof D ? this.copyNode(r) : !1;
  }
  moveNode(e, r, n) {
    this.deleteNode(e);
    let o = r;
    return ["AFTER", "BEFORE"].includes(n) && (o = r.parent), e.parent = o, this.addNode(e, r, n);
  }
  moveNodeById(e, r, n) {
    const o = this.getNode(e), a = this.getNode(r);
    return o && a && o instanceof D && a instanceof D ? this.moveNode(o, a, n) : !1;
  }
  // replaceNode(targetNode, node) {}
  deleteNode(e) {
    var r;
    const n = e.parent;
    if (!n)
      throw new Error("parent node is null or undefined, pls check it");
    if (n instanceof Dt) {
      const o = n.value.value, a = o.findIndex((i) => i === e), s = o[a];
      return o.splice(a, 1), (r = n.parent) == null || r.updateValue(), s;
    }
    if (n instanceof D || n instanceof ne) {
      const o = n.value.children, a = o.findIndex((i) => i === e), s = o[a];
      return o.splice(a, 1), n.updateValue(), s;
    }
  }
  deleteNodeById(e) {
    const r = this.getNode(e);
    if (r)
      return this.deleteNode(r);
  }
  export(e = Vr.SAVE) {
    var r;
    const n = this.data.componentsTree.export(e), o = this.assetPackagesList, a = [], s = this.materialsModel.usedMaterials.map((c) => {
      const u = o.find((d) => {
        var f;
        return d.package === ((f = c.value.npm) == null ? void 0 : f.package);
      });
      return u && a.push(u), {
        componentName: c.componentName,
        ...ca(c.value.npm || {})
      };
    }).filter((c) => c.componentName && c.package && c.version ? !0 : (console.warn(`${JSON.stringify(c, null, 2)} not a valid material info`), !1));
    this.materialsModel.usedMaterials = [];
    let i = {
      ...this.data,
      componentsTree: Gr(n),
      componentsMeta: s,
      thirdLibs: this.data.thirdLibs,
      assets: [],
      extra: this.data.extra
    };
    return (r = this.data.thirdLibs) == null || r.forEach((c) => {
      const u = o.find((d) => c.package === d.package);
      u && a.push(u);
    }), i.assets = cg(a, (c) => c.package), i = va(i, ["id"]), JSON.parse(JSON.stringify(i));
  }
  getRootNode() {
    return this.data.componentsTree;
  }
}
rt.ROOT_CONTAINER;
const Re = "DYNAMIC", Vg = ["$$context", "$$nodeModel"], Na = "ON_DID_RENDER", ja = "ON_WILL_DESTROY", Ug = [Na, ja], fr = (t, e) => {
  let r = t;
  return e && (r = {
    ...t
  }, r.__proto__ = e || null), r;
}, oe = (t, e = {}, ...r) => typeof t == "string" || typeof t == "number" ? String(t) : (Vg.forEach((o) => {
  o in e && t.__CP_TYPE__ !== Re && delete e[o];
}), x.createElement(t, e, ...r)), Zn = (t = {}, e) => {
  const r = [], n = (o, a) => {
    let s = a;
    lr(a) && (s = a.value), e(s) ? r.push({
      keyPath: o,
      val: s
    }) : ot(s) ? s.forEach((i, c) => {
      n([...o, String(c)], i);
    }) : Ft(s) && Object.keys(s).forEach((i) => {
      n([...o, i], s[i]);
    });
  };
  return n(["$root"], t), r;
}, Rt = (t, e) => {
  const r = t.handler, { context: n, storeManager: o } = e;
  return e.actionVariableSpace || (e.actionVariableSpace = {}), async function(...a) {
    const s = {}, i = async (d) => {
      const f = d;
      if (f.type === "RUN_CODE") {
        const l = se({
          funcName: "",
          funcBody: `function() {
${f.value}
}`,
          nodeContext: n,
          storeManager: o,
          $$response: e.$$response,
          actionVariableSpace: e.actionVariableSpace,
          nodeModel: e.nodeModel
        });
        let h;
        e.$$response !== void 0 ? h = l(e.$$response, ...a) : h = l(...a), h != null && h.then ? s[f.id] = await h : s[f.id] = h;
      }
      if (f.type === "JUMP_LINK") {
        const h = Bg(f, e)(...a);
        h != null && h.then ? s[f.id] = await h : s[f.id] = h;
      }
      if (f.type === "REQUEST_API") {
        const { run: l, afterFailedResponse: h, afterSuccessResponse: v } = Gg(f, e);
        try {
          const _ = l(...a);
          _ != null && _.then ? s[f.id] = await _ : s[f.id] = _, f.responseVarName && (e.actionVariableSpace[f.responseVarName] = s[f.id]);
          const p = v(s[f.id], ...a);
          return p != null && p.then ? await p : p;
        } catch (_) {
          const p = await h(_);
          return p != null && p.then ? await p : p;
        }
      }
      if (f.type === "CALL_NODE_METHOD") {
        const h = zg(f, e)(...a);
        h != null && h.then ? s[f.id] = await h : s[f.id] = h, f.returnVarName && (e.actionVariableSpace[f.returnVarName] = s[f.id]);
      }
      if (f.type === "ASSIGN_VALUE") {
        const l = kg(f, e);
        let h = [...a];
        e.$$response !== void 0 && (h = [e.$$response, h]);
        const v = l(...h);
        s[f.id] = await v;
      }
    };
    let c = r[0];
    const u = /* @__PURE__ */ new Set();
    for (; c; ) {
      if (u.has(c.id))
        return;
      await i(c), u.add(c.id), c = r.find((f) => (c == null ? void 0 : c.next) && f.id === (c == null ? void 0 : c.next));
    }
  };
};
function Bg(t, e) {
  return yt(t.link, e);
}
const yt = (t, e) => function(...r) {
  return mt(t) ? At(t.value, {
    ...e.context,
    nodeContext: e.context,
    storeManager: e.storeManager,
    $$response: e.$$response,
    actionVariableSpace: e.actionVariableSpace,
    nodeModel: e.nodeModel
  }) : wa(t) ? se({
    funcName: t.name || "",
    funcBody: t.value,
    nodeContext: e.context,
    storeManager: e.storeManager,
    $$response: e.$$response,
    actionVariableSpace: e.actionVariableSpace,
    nodeModel: e.nodeModel
  })(...r) : t;
}, Gg = (t, e) => ({
  run: function(...a) {
    var l, h;
    let s = "";
    t.apiPath && (s = yt(t.apiPath, e)(...a));
    const i = t.body || {};
    Object.keys(i).forEach((v) => {
      i[v] = yt(i[v], e)(...a);
    });
    const c = t.query || {};
    Object.keys(c).forEach((v) => {
      c[v] = yt(c[v], e)(...a);
    });
    const u = t.header || {};
    Object.keys(u).forEach((v) => {
      u[v] = yt(u[v], e)(...a);
    });
    const d = t.method || "GET";
    return (h = (l = e.context).requestAPI) == null ? void 0 : h.call(l, {
      url: s,
      method: d,
      header: u,
      body: i,
      query: c
    });
  },
  afterSuccessResponse: async (a, ...s) => {
    if (!t.afterSuccessResponse)
      return a;
    const i = [...t.afterSuccessResponse || [], ...t.afterFailedResponse || []];
    return Rt(
      {
        handler: i
      },
      {
        ...e,
        $$response: a
      }
    )(...s);
  },
  afterFailedResponse: async (a, ...s) => {
    if (!t.afterFailedResponse)
      return a;
    const i = [...t.afterFailedResponse || [], ...t.afterSuccessResponse || []];
    return Rt(
      {
        handler: i
      },
      {
        ...e,
        $$response: a
      }
    )(...s);
  }
}), zg = (t, e) => (...r) => {
  const n = se({
    funcName: "",
    funcBody: `
      function () {
        var args  = arguments;
        var nodeRef = $$context.nodeRefs.get(${JSON.stringify(t.nodeId)});
        if(nodeRef && nodeRef.current) {
          var func = nodeRef.current[${JSON.stringify(t.methodName)}]?.bind(nodeRef.current);
          var isDev = Boolean(nodeRef.current?.getTargetComponentRef);
          if (isDev) {
            const ins = nodeRef.current.getTargetComponentRef()?.current;
            func = ins?.[${JSON.stringify(t.methodName)}]?.bind(ins);
          }
          if (func) {
            func.apply(null, args);
          }
        }
      }`,
    nodeContext: e.context,
    storeManager: e.storeManager,
    $$response: e.$$response,
    nodeModel: e.nodeModel
  });
  let o = r;
  return Array.isArray(t.args) && (o = t.args.map((a) => {
    const s = [e.$$response, ...r].filter(Boolean);
    return yt(a, e)(...s);
  })), n(...o);
}, kg = (t, e) => async (...r) => {
  const o = yt(t.currentValue, e)(...r);
  let a;
  if (o != null && o.then ? a = await o : a = o, t.valueType === "STATE") {
    const s = t.targetValueName, i = e.storeManager.getStore(s.nodeId);
    i && i.setState({
      [s.keyPath]: a
    });
  } else t.valueType === "MEMORY" && (e.actionVariableSpace[t.targetValueName] = a);
  return a;
}, de = (t = {}, e) => {
  const { $$context: r, getComponent: n, storeManager: o } = e, a = t, s = (c) => {
    if (Array.isArray(c))
      return c.map((u) => s(u));
    if (lr(c))
      return s(c.value);
    if (Mg(c)) {
      const u = c.value, d = u.value;
      if (!d)
        return console.warn("slot value is null, this maybe cause some error, pls check it", t), () => {
        };
      const f = (l) => {
        const h = `${l.id}-${Re}`, v = n(l), _ = kr(v, l, {
          ...e
        }), p = u.params || [];
        return {
          component: (...b) => {
            const y = Po(b, p), S = fr(
              {
                params: y,
                nodeRefs: r.nodeRefs,
                // 使用空函数，避免获取到父节点的方法或者函数
                getProps: function() {
                },
                callEventMethod: function() {
                }
              },
              r
            );
            return oe(_, {
              $$context: S,
              key: h
            });
          },
          key: h
        };
      };
      if (Array.isArray(d)) {
        const l = d == null ? void 0 : d.map((h) => f(h));
        return (...h) => l.map((v) => {
          if (Bu(v.component)) {
            const p = v.component;
            return x.createElement(p, {
              $$context: r,
              key: v.key
            });
          } else {
            const p = v.component;
            return p == null ? void 0 : p(...h);
          }
        });
      } else
        return f(d).component;
    } else {
      if (mt(c))
        return At(c.value, {
          nodeContext: r,
          storeManager: e.storeManager,
          nodeModel: e.nodeModel
        });
      if (wa(c)) {
        const u = c;
        return se({
          funcBody: u.value,
          funcName: u.name || "",
          nodeContext: r,
          storeManager: o,
          nodeModel: e.nodeModel
        });
      } else {
        if (Tg(c))
          return Rt(c, {
            context: r,
            storeManager: o,
            actionVariableSpace: {},
            nodeModel: e.nodeModel
          });
        if (Ft(c)) {
          let u = c;
          lr(c) && (u = c.value);
          const d = u, f = {};
          return Object.keys(u).forEach((l) => {
            f[l] = s(d[l]);
          }), f;
        } else
          return c;
      }
    }
  }, i = {};
  return Object.keys(a).forEach((c) => {
    const u = a[c];
    i[c] = s(u);
  }), i;
}, Hg = (t, e) => {
  const { runtimeComponentCache: r, $$context: n = {}, getComponent: o, renderMode: a } = e, { $$context: s, idx: i, ...c } = e;
  return typeof t == "string" ? oe(t) : Rg(t) ? (({ currentNode: d }) => {
    const f = d.value.id;
    let l = null;
    if (r.get(f)) {
      const _ = r.get(f);
      l = _ == null ? void 0 : _.component;
    } else {
      const _ = o(d);
      l = kr(_, d, {
        ...c
      }), !r.get(f) && a !== "design" && r.set(f, {
        component: l
      });
    }
    const h = `${f}-${Re}`;
    return oe(l, {
      $$context: n,
      $$nodeModel: t,
      key: h
    });
  })({
    currentNode: t
  }) : void 0;
}, kr = (t, e, r) => {
  const {
    storeManager: n,
    variableManager: o,
    onGetRef: a,
    onComponentMount: s,
    onComponentDestroy: i,
    refManager: c,
    processNodeConfigHook: u,
    requestAPI: d,
    doc: f
  } = r, { ...l } = r;
  class h extends x.Component {
    constructor(p) {
      super(p);
      $(this, "_CONDITION", !0);
      $(this, "_DESIGN_BOX", !1);
      $(this, "_NODE_MODEL", e);
      $(this, "_NODE_ID", e.id);
      $(this, "UNIQUE_ID", `${e.id}_${et()}`);
      $(this, "targetComponentRef");
      $(this, "listenerHandler", []);
      $(this, "storeState");
      /** 存储清理 store 的监听函数 */
      $(this, "storeListenDisposeList", []);
      /** save dom and media css */
      $(this, "domHeader");
      $(this, "mediaStyleDomMap", {});
      /** 存储当前节点的一些变量和方法，不具有响应性 */
      $(this, "variableSpace");
      $(this, "nodeName");
      $(this, "updateState", (p) => {
        e.value.componentName === rt.ROOT_CONTAINER ? this.setState(p) : this.storeState.setState(p);
      });
      $(this, "getStyleDomById", (p) => {
        const g = this.mediaStyleDomMap;
        let m = g[p];
        return m || (m = f.createElement("style"), g[p] = m), m.id = p, m;
      });
      $(this, "addMediaCSS", () => {
        var m;
        let p = this.domHeader;
        if (p || (p = (m = f.getElementsByTagName("head")) == null ? void 0 : m[0], this.domHeader = p), !this.domHeader) {
          console.warn("not found header dom");
          return;
        }
        const g = this._NODE_MODEL.value.css;
        g && g.value.forEach((b) => {
          var j;
          const y = `${this.UNIQUE_ID}_${b.state}`;
          let S = yn(this._NODE_MODEL);
          if (b.state !== "normal" && (S = `${S}:${b.state}`), b.text) {
            const N = this.getStyleDomById(y);
            N.innerText = `.${S} { ${b.text} }`, p == null || p.appendChild(N);
          }
          (j = b.media) != null && j.length && b.media.forEach((N) => {
            const w = `${y}_${N.type}_${N.value}`, V = this.getStyleDomById(w);
            V.media = `screen and (${N.type}:${N.value}px)`, V.innerHTML = `.${S} { ${N.text} }`, p == null || p.appendChild(V);
          });
        });
      });
      $(this, "removeMediaCSS", () => {
        const p = this.mediaStyleDomMap;
        Object.keys(p).forEach((g) => {
          var m;
          (m = this.domHeader) == null || m.removeChild(p[g]);
        }), this.mediaStyleDomMap = {};
      });
      $(this, "rebuildNode", () => {
        this.storeListenDisposeList.forEach((p) => p()), this.removeMediaCSS(), this.connectStore(), this.addMediaCSS(), this.forceUpdate();
      });
      this.targetComponentRef = x.createRef(), this.listenerHandler = [], this.state = e.value.state || {};
      let g = e.value.nodeName || e.id;
      e.value.componentName === rt.ROOT_CONTAINER && (g = "globalState"), this.nodeName = g;
      const m = n.getStore(g);
      m ? (this.storeState = m, m.setState({
        ...e.value.state || {}
      })) : this.storeState = n.addStore(g, () => ({
        ...e.value.state || {}
      }));
      const b = this.storeState.subscribe((S) => {
        this.setStateIfChanged(S);
      });
      this.storeListenDisposeList.push(b), this.connectStore();
      const y = o.get(g);
      y ? this.variableSpace = y : (this.variableSpace = {
        staticVar: {},
        methods: {}
      }, o.add(g, this.variableSpace));
    }
    /** 如果值和当前 state 一样了就不触发更新 */
    setStateIfChanged(p) {
      e.value.componentName !== rt.ROOT_CONTAINER && this.setState((g) => {
        const m = typeof p == "function" ? p(g) : p;
        return Vu(g, { ...g, ...m }) ? null : m;
      });
    }
    connectStore() {
      const p = Zn(e.props, (S) => !!mt(S)), g = Zn(
        {
          css: e.value.css,
          class: e.value.classNames
        },
        (S) => !!mt(S)
      );
      let m = [];
      [...p, ...g].map((S) => {
        const j = S.val, N = [
          // 匹配 $$context.stateManger.xxx.state
          new RegExp(`(?<=context\\.stateManager(?:\\.|\\[["'])?)\\w+(?=(?:["']?\\])?(?:\\.|\\[)?["']?state)`, "gim"),
          // 匹配 $ALL_STATE.xxx;
          /\$ALL_STATE(?:\.|(?:\[\s*["']))(\w+)(?=(?:["']\s*\])?)/gim,
          // 匹配 getStateObj("xxx")
          /getStateObj\(["']([^"']+)["']\)/gim
        ], w = Hu(j.value, N);
        m = [...m, ...w], /\$CTX\.globalState|\$G_STATE/.test(j.value) && m.push("globalState");
      }).filter(Boolean);
      const b = Array.from(new Set(m)), y = [];
      b.length && b.forEach((S) => {
        if (!S)
          return;
        n.getStore(S) || (n.addStore(S, () => ({})), console.warn(n, S, "not exits, auto create"));
        const N = n.connect(S, (w) => {
          this.setStateIfChanged(w);
        });
        y.push(N);
      }), this.storeListenDisposeList = y;
    }
    componentDidMount() {
      var m;
      this.addMediaCSS(), a == null || a(this.targetComponentRef, e, this), s == null || s(this, e);
      const p = (m = e.value.eventListener) == null ? void 0 : m.find((b) => b.name === Na);
      p && Rt(p.func, {
        context: this.createCurrentNodeCtx(),
        storeManager: n,
        actionVariableSpace: {},
        nodeModel: e
      })();
      const g = () => {
        n.setStore(e.value.nodeName || e.id, this.storeState), this.storeState.setState({
          ...this.state,
          ...e.value.state || {}
        }), this.rebuildNode();
      };
      e.onChange(g);
    }
    componentWillUnmount() {
      var m;
      this.storeListenDisposeList.forEach((b) => b()), this.removeMediaCSS(), i == null || i(this, e);
      const p = ja, g = (m = e.value.eventListener) == null ? void 0 : m.find((b) => b.name === p);
      g && Rt(g.func, {
        context: this.createCurrentNodeCtx(),
        storeManager: n,
        actionVariableSpace: {},
        nodeModel: e
      })();
    }
    /** 转换节点的 methods */
    transformMethods(p) {
      const { context: g } = p, m = de(
        {
          methods: e.value.methods
        },
        {
          $$context: g,
          ...l,
          nodeModel: e
        }
      ), b = e.value.methods || [], y = m.methods, S = b.reduce((j, N, w) => (j[N.name] = y[w], j), {});
      g.methods = S, this.variableSpace.methods = Object.assign(this.variableSpace.methods, S);
    }
    /** 处理根节点的 context */
    processRootContext(p) {
      e.value.componentName === rt.ROOT_CONTAINER && (p.globalState = this.state, p.updateGlobalState = this.updateState, p.requestAPI = d, p.getGlobalState = () => this.state);
    }
    processNodeClassName(p, g) {
      var y;
      const m = ((y = e.value.classNames) == null ? void 0 : y.map((S) => {
        var w;
        const j = S.name;
        return (mt(S.status) ? At(((w = S.status) == null ? void 0 : w.value) || "", {
          nodeContext: g,
          nodeModel: e,
          storeManager: n
        }) : !1) ? j : "";
      })) || [];
      let b = `${p ?? ""} ${m.join(" ")}`.trim();
      return e.value.css && (b = `${yn(e)} ${b}`.trim()), b;
    }
    processNodeStyle(p) {
      if (!e.value.style)
        return {};
      const g = de(
        { style: e.value.style },
        {
          $$context: p,
          ...l,
          nodeModel: e
        }
      );
      return ku(g.style || []);
    }
    processNodeChild(p, g) {
      let m = [];
      if (p !== void 0)
        m = Array.isArray(p) ? p : [p];
      else {
        const b = [];
        e.value.children.forEach((S, j) => {
          const N = Hg(S, {
            $$context: g,
            idx: j,
            ...l
          });
          b.push(N);
        }), m = b;
      }
      return m;
    }
    processNodeConditionAndConfigHook(p, g, m) {
      let b = e.value.condition ?? !0;
      typeof b != "boolean" && (b = At(b.value, {
        nodeContext: m || {},
        nodeModel: e,
        storeManager: n
      }));
      let y = {
        condition: b,
        props: p
      };
      u && (y = u(y, e));
      const S = oe(t, y.props, ...g);
      return this._CONDITION = y.condition, y.condition ? S : x.createElement(
        "div",
        {
          key: p.key,
          style: {
            display: "none"
          }
        },
        S
      );
    }
    processNodeEventListener(p) {
      const g = e.value.eventListener, m = {};
      return g == null || g.forEach((b) => {
        if (Ug.includes(b.name))
          return;
        const y = Rt(b.func, {
          context: p,
          storeManager: n,
          actionVariableSpace: {},
          nodeModel: e
        });
        m[b.name] = y;
      }), m;
    }
    createCurrentNodeCtx() {
      const { $$context: p } = this.props, g = e.value.nodeName || e.id, m = e.id, b = {
        state: this.state || {},
        staticVar: this.variableSpace.staticVar,
        updateState: this.updateState,
        storeManager: n,
        getState: () => n.getStateObj(g),
        getStateObj: () => n.getStateObj(g),
        getStateObjById: (S) => n.getStateObj(S),
        stateManager: n.getStateSnapshot(),
        getMethods: () => {
          const S = o.get(m).methods, j = c.get(m).current;
          return bn(S, j);
        },
        getMethodsById: (S) => {
          const j = o.get(S).methods, N = c.get(S).current;
          return bn(j, N);
        },
        getStaticVar: () => o.get(g).staticVar,
        getStaticVarById: (S) => o.get(S).staticVar,
        /** 获取当前节点的事件函数 */
        callEventMethod: (S, j) => {
          var w, V;
          const N = c.get(m).current;
          (V = N == null ? void 0 : (w = N.props)[S]) == null || V.call(w, j);
        },
        /** 获取当前 node 的 props  */
        getProps: () => {
          const S = c.get(m).current;
          return S == null ? void 0 : S.props;
        },
        nodeRefs: p.nodeRefs
      };
      return this.processRootContext(b), fr(b, p);
    }
    injectEngEnv() {
      const p = {}, g = e.value.injectEnvList || [];
      if (Array.isArray(e.value.injectEnvList)) {
        const m = {
          [Ea.COMPONENTS]: r.components
        };
        g.reduce((b, y) => (b[y] = m[y], b), p);
      }
      return p;
    }
    renderCore() {
      const { $$context: p, ...g } = this.props, m = {
        key: e.id,
        ...e.props,
        ...g
      }, b = this.createCurrentNodeCtx();
      this.transformMethods({ context: b });
      let y = de(m, {
        $$context: b,
        ...l,
        nodeModel: e
      });
      const S = this.injectEngEnv();
      Object.assign(y, S);
      const j = this.processNodeClassName(y.className, b);
      y.className = j;
      const N = this.processNodeStyle(b);
      y.style = {
        ...(y == null ? void 0 : y.style) || {},
        ...N || {}
      };
      const { children: w } = y;
      delete y.children;
      const V = this.processNodeChild(w, b);
      if (y.ref = this.targetComponentRef, e.value.eventListener) {
        const gt = this.processNodeEventListener(b);
        y = {
          ...y,
          ...gt
        };
      }
      return this.processNodeConditionAndConfigHook(y, V, b);
    }
    renderLoop() {
      const { $$context: p, ...g } = this.props, m = {
        key: e.id,
        ...e.props,
        ...g
      }, b = this.createCurrentNodeCtx();
      this.transformMethods({ context: b });
      const y = e.value.loop;
      let S = [];
      if (y && y.open) {
        this.targetComponentRef.current = [];
        let j = y.data || [];
        if (mt(y.data)) {
          const N = y.data;
          j = At(N.value, {
            nodeContext: b || {},
            storeManager: n,
            nodeModel: e
          }) || [];
        }
        return S = j.map((...N) => {
          const w = N[1], V = [y.forName || "item", y.forIndex || "index"], ht = Po(N, V);
          let gt = "loopData";
          y.name && (gt = `${gt}${y.name}`);
          const vt = fr(
            {
              [gt]: ht,
              nodeRefs: b.nodeRefs,
              // 使用空函数，避免获取到父节点的方法或者函数
              getProps: function() {
              },
              callEventMethod: function() {
              }
            },
            b
          );
          let F = de(m, {
            $$context: vt,
            ...l,
            nodeModel: e
          });
          const Ta = this.injectEngEnv();
          Object.assign(F, Ta);
          const Ra = this.processNodeClassName(F.className, vt);
          F.className = Ra;
          const Ma = this.processNodeStyle(vt);
          F.style = {
            ...(F == null ? void 0 : F.style) || {},
            ...Ma || {}
          };
          const { children: Pa } = F;
          delete F.children;
          const Ia = this.processNodeChild(Pa, vt);
          if (F.key = `${F.key}-${w}`, mt(y.key)) {
            const zt = y.key, Da = At(zt.value, {
              nodeContext: vt || {},
              storeManager: n,
              nodeModel: e
            });
            F.key += `-${Da}`;
          }
          if (F.ref = (zt) => {
            this.targetComponentRef.current = this.targetComponentRef.current || [], this.targetComponentRef.current[w] = zt;
          }, e.value.eventListener) {
            const zt = this.processNodeEventListener(vt);
            F = {
              ...F,
              ...zt
            };
          }
          return this.processNodeConditionAndConfigHook(F, Ia, vt);
        }), S;
      }
    }
    render() {
      const p = e.value.loop;
      return p && p.open ? this.renderLoop() : this.renderCore();
    }
  }
  return $(h, "__CP_TYPE__", Re), h.displayName = `${e.value.componentName}Dynamic`, h;
};
class Jg {
  constructor() {
    $(this, "renderMode", "normal");
    $(this, "components", {});
    $(this, "storeManager", new Ku());
    // 存储节点的变量或者方法
    $(this, "variableManager", new Qu());
    $(this, "runtimeComponentCache", /* @__PURE__ */ new Map());
    $(this, "onGetRef");
    $(this, "onGetComponent");
    $(this, "onComponentMount");
    $(this, "refManager", new Do());
    $(this, "onComponentDestroy");
    /**
     * 处理 props 钩子, 可以统一拦截 node 的处理，并修改其值
     */
    $(this, "processNodeConfigHook");
    /** 请求 API */
    $(this, "requestAPI", async (e) => {
      throw console.log(e), new Error("Need to implement requestAPI for Render");
    });
  }
  /**
   * 根据 node 获取对应渲染的组件
   * @param currentNode
   * @returns
   */
  getComponent(e) {
    var o;
    const r = e.value.componentName;
    let n = Ju(r, this.components);
    return Gu(n) || (n = zu(n), this.components[r] = n), this.onGetComponent && (n = (o = this.onGetComponent) == null ? void 0 : o.call(this, n, e)), n;
  }
  pageRender(e, {
    components: r,
    onGetRef: n,
    refManager: o,
    $$context: a = {
      nodeRefs: o,
      // 使用空函数，避免获取到父节点的方法或者函数
      getProps: function() {
      },
      callEventMethod: function() {
      }
    },
    onGetComponent: s,
    onComponentMount: i,
    onComponentDestroy: c,
    renderMode: u,
    processNodeConfigHook: d,
    requestAPI: f,
    doc: l
  }) {
    this.renderMode = u, this.components = r, this.onGetRef = n, this.onGetComponent = s, this.onComponentMount = i, this.onComponentDestroy = c, this.processNodeConfigHook = d, this.refManager = o, this.requestAPI = f;
    const h = e.value.componentsTree, v = this.getComponent(h), _ = kr(v, e.value.componentsTree, {
      storeManager: this.storeManager,
      variableManager: this.variableManager,
      runtimeComponentCache: this.runtimeComponentCache,
      getComponent: this.getComponent.bind(this),
      refManager: this.refManager,
      onGetRef: this.onGetRef,
      processNodeConfigHook: d,
      onComponentMount: i,
      onComponentDestroy: c,
      renderMode: u,
      requestAPI: f,
      components: this.components,
      doc: l
    }), p = {}, g = h.props;
    return Object.keys(g).forEach((m) => {
      p[m] = g[m].value;
    }), p.$$context = a, oe(_, p);
  }
  clear() {
    this.runtimeComponentCache.clear(), this.storeManager.destroy();
  }
}
const Nv = za(new Jg()), Wg = [
  "a",
  "abbr",
  "acronym",
  "address",
  "applet",
  "area",
  "article",
  "aside",
  "audio",
  "b",
  "base",
  "basefont",
  "bdi",
  "bdo",
  "bgsound",
  "big",
  "blink",
  "blockquote",
  "body",
  "br",
  "button",
  "canvas",
  "caption",
  "center",
  "cite",
  "code",
  "col",
  "colgroup",
  "command",
  "content",
  "data",
  "datalist",
  "dd",
  "del",
  "details",
  "dfn",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "element",
  "em",
  "embed",
  "fieldset",
  "figcaption",
  "figure",
  "font",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hgroup",
  "hr",
  "html",
  "i",
  "iframe",
  "image",
  "img",
  "input",
  "ins",
  "isindex",
  "kbd",
  "keygen",
  "label",
  "legend",
  "li",
  "link",
  "listing",
  "main",
  "map",
  "mark",
  "marquee",
  "math",
  "menu",
  "menuitem",
  "meta",
  "meter",
  "multicol",
  "nav",
  "nextid",
  "nobr",
  "noembed",
  "noframes",
  "noscript",
  "object",
  "ol",
  "optgroup",
  "option",
  "output",
  "p",
  "param",
  "picture",
  "plaintext",
  "pre",
  "progress",
  "q",
  "rb",
  "rbc",
  "rp",
  "rt",
  "rtc",
  "ruby",
  "s",
  "samp",
  "script",
  "search",
  "section",
  "select",
  "shadow",
  "slot",
  "small",
  "source",
  "spacer",
  "span",
  "strike",
  "strong",
  "style",
  "sub",
  "summary",
  "sup",
  "svg",
  "table",
  "tbody",
  "td",
  "template",
  "textarea",
  "tfoot",
  "th",
  "thead",
  "time",
  "title",
  "tr",
  "track",
  "tt",
  "u",
  "ul",
  "var",
  "video",
  "wbr",
  "xmp"
], ct = (t) => {
  const e = {};
  return t.forEach((r) => {
    e[r.key] = r.value;
  }), e;
}, qg = Wg.reduce((t, e) => (t[e] = ({ children: r, $$attributes: n = [], ...o }) => {
  let a = r;
  Array.isArray(r) || (a = [r]);
  const s = {
    boxSizing: "border-box",
    ...o.style || {}
  };
  return x.createElement(
    e,
    {
      ...o,
      ...ct(n),
      style: s
    },
    ...a
  );
}, t), {}), Kg = ({ children: t, width: e, height: r, $$attributes: n = [], ...o }) => {
  let a = t;
  Array.isArray(t) || (a = [t]), a = a.filter((u) => u !== void 0);
  const { style: s = {}, ...i } = ct(n), c = {
    height: r,
    width: e,
    boxSizing: "border-box",
    ...s,
    ...o.style || {}
  };
  return x.createElement(
    "div",
    {
      ...o,
      ...i,
      style: c
    },
    ...a
  );
}, Qg = ({ afterMount: t, beforeDestroy: e, $$attributes: r = [], ...n }) => {
  oo(() => (t == null || t(n), () => {
    e == null || e(n);
  }), []);
  const o = {
    boxSizing: "border-box",
    ...n.style || {}
  };
  return x.createElement("canvas", {
    ...n,
    ...ct(r),
    style: o
  });
}, Yg = ({ children: t, $$attributes: e = [], ...r }) => {
  let n = t;
  Array.isArray(t) || (n = [t]);
  const o = {
    boxSizing: "border-box",
    ...r.style || {}
  };
  return x.createElement(
    "img",
    {
      ...r,
      ...ct(e),
      style: o
    },
    ...n
  );
}, Xg = ({ children: t, $$attributes: e = [], ...r }) => {
  let n = t;
  Array.isArray(t) || (n = [t]);
  const o = {
    boxSizing: "border-box",
    ...r.style || {}
  };
  return x.createElement(
    "video",
    {
      ...r,
      ...ct(e),
      style: o
    },
    ...n
  );
}, Zg = ({ children: t, $$attributes: e = [], ...r }) => {
  let n = t;
  Array.isArray(t) || (n = [t]);
  const o = {
    boxSizing: "border-box",
    ...r.style || {}
  };
  return x.createElement(
    "audio",
    {
      ...r,
      ...ct(e),
      style: o
    },
    ...n
  );
}, tv = ({ $$attributes: t = [], content: e, ...r }) => {
  const n = {
    boxSizing: "border-box",
    ...r.style || {}
  };
  return x.createElement(
    "span",
    {
      ...r,
      ...ct(t),
      style: n
    },
    e
  );
}, ev = ({ children: t, $$attributes: e = [], afterMount: r, beforeDestroy: n, style: o, ...a }) => {
  let s = t;
  Array.isArray(t) || (s = [t]), oo(() => (r == null || r(a), () => {
    n == null || n(a);
  }), []);
  const i = {
    boxSizing: "border-box",
    ...o || {}
  };
  return x.createElement(
    "div",
    {
      ...a,
      ...ct(e),
      style: i
    },
    ...s
  );
}, rv = ({ children: t, $$attributes: e = [], htmlTag: r = "div", ...n }) => {
  let o = t;
  Array.isArray(t) || (o = [t]);
  const { style: a = {}, ...s } = ct(e), i = {
    boxSizing: "border-box",
    ...a,
    ...n.style || {}
  };
  return x.createElement(
    r,
    {
      ...n,
      ...s,
      style: i
    },
    ...o
  );
}, nv = {
  RootContainer: ({ children: t }) => t,
  ...qg,
  CContainer: ev,
  CVideo: Xg,
  CAudio: Zg,
  CBlock: Kg,
  CImage: Yg,
  CText: tv,
  CCanvas: Qg,
  CNativeTag: rv
};
class ov extends x.Component {
  constructor(r) {
    super(r);
    $(this, "refManager");
    // save component instance
    $(this, "dynamicComponentInstanceMap", /* @__PURE__ */ new Map());
    $(this, "onGetRef", (r, n, o) => {
      var a, s;
      (s = (a = this.props).onGetRef) == null || s.call(a, r, n, o), this.dynamicComponentInstanceMap.set(n.id, o), this.refManager.add(n.value.refId || n.id, r);
    });
    $(this, "rerender", (r) => {
      if (this.props.adapter.clear(), (r == null ? void 0 : r.nodeType) === "PAGE" && r)
        this.setState({
          pageModel: r
        });
      else if (Ft(r) && Ca(r)) {
        const n = r;
        this.setState({
          pageModel: new Se(n, {
            materials: this.state.pageModel.materialsModel.rawValue
          })
        });
      }
    });
    this.state = {
      pageModel: r.pageModel || new Se(r.page)
    }, this.refManager = new Do();
  }
  getPageModel() {
    return this.state.pageModel;
  }
  componentDidMount() {
    const { render: r } = this.props;
    r && (r.ref.current = this), window.parent && (window.parent.__CB_RENDER_WIN__ = window);
  }
  componentWillUnmount() {
    this.refManager.destroy();
  }
  render() {
    const { props: r } = this, { adapter: n, onGetComponent: o, onComponentDestroy: a, onComponentMount: s, doc: i } = r, { pageModel: c } = this.state;
    if (!c)
      return console.warn("pageModel is null"), null;
    const u = {
      ...nv,
      ...r.components
    }, d = this.props.$$context || {};
    return n.pageRender(c, {
      libs: {},
      components: u,
      refManager: this.refManager,
      onGetRef: this.onGetRef,
      onGetComponent: o,
      onComponentMount: s,
      onComponentDestroy: a,
      $$context: {
        ...d,
        nodeRefs: this.refManager
      },
      renderMode: r.renderMode || "normal",
      requestAPI: r.requestAPI ?? n.requestAPI,
      processNodeConfigHook: r.processNodeConfigHook,
      doc: i || document
    });
  }
}
const jv = () => {
  const t = ao(null);
  return so(() => ({
    ref: t,
    rerender: function(...r) {
      t.current && t.current.rerender(...r);
    }
  }), []);
};
class av extends x.Component {
  constructor(r) {
    super(r);
    $(this, "onDoubleClick", () => {
      this.setState({
        hasError: !1,
        error: null
      });
    });
    this.state = { hasError: !1, error: "" };
  }
  static getDerivedStateFromError(r) {
    return { hasError: !0, error: r };
  }
  componentDidCatch(r, n) {
    var o, a;
    (a = (o = this.props).onError) == null || a.call(o, n);
  }
  render() {
    if (this.state.hasError) {
      const { onDoubleClick: r } = this, n = this.props.node.value;
      console.error(this.props.node, this.props.children);
      const o = x.createElement(
        "div",
        {
          style: {
            backgroundColor: "rgb(255 206 215 / 13%)",
            padding: "5px",
            color: "#ff0000b0",
            textAlign: "center",
            fontSize: "12px"
          }
        },
        "Render error, node id: ",
        n.id,
        ", node name：",
        n.title,
        " component name：",
        n.title || n.componentName,
        x.createElement("p", null, "msg: ", String(this.state.error)),
        x.createElement(
          "button",
          {
            onDoubleClick: r,
            style: {
              border: "1px solid rgba(100,100,100,0.1)",
              backgroundColor: "#fff",
              padding: "5px 10px",
              borderRadius: "2px",
              color: "gray",
              cursor: "pointer",
              marginTop: "5px"
            }
          },
          "double click to refresh"
        ),
        x.createElement("div", {
          style: {
            display: "none"
          }
        })
      );
      return x.createElement(this.props.targetComponent, { onlyRenderChild: !0 }, o);
    }
    return this.props.children;
  }
}
function sv(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var Ge = { exports: {} }, H = {};
/**
 * @license React
 * react-reconciler-reflection.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var to;
function iv() {
  if (to) return H;
  to = 1;
  function t(s) {
    var i = "https://react.dev/errors/" + s;
    if (1 < arguments.length) {
      i += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var c = 2; c < arguments.length; c++)
        i += "&args[]=" + encodeURIComponent(arguments[c]);
    }
    return "Minified React error #" + s + "; visit " + i + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function e(s) {
    var i = s, c = s;
    if (s.alternate) for (; i.return; ) i = i.return;
    else {
      s = i;
      do
        i = s, (i.flags & 4098) !== 0 && (c = i.return), s = i.return;
      while (s);
    }
    return i.tag === 3 ? c : null;
  }
  function r(s) {
    if (e(s) !== s)
      throw Error(t(188));
  }
  function n(s) {
    var i = s.alternate;
    if (!i) {
      if (i = e(s), i === null) throw Error(t(188));
      return i !== s ? null : s;
    }
    for (var c = s, u = i; ; ) {
      var d = c.return;
      if (d === null) break;
      var f = d.alternate;
      if (f === null) {
        if (u = d.return, u !== null) {
          c = u;
          continue;
        }
        break;
      }
      if (d.child === f.child) {
        for (f = d.child; f; ) {
          if (f === c) return r(d), s;
          if (f === u) return r(d), i;
          f = f.sibling;
        }
        throw Error(t(188));
      }
      if (c.return !== u.return) c = d, u = f;
      else {
        for (var l = !1, h = d.child; h; ) {
          if (h === c) {
            l = !0, c = d, u = f;
            break;
          }
          if (h === u) {
            l = !0, u = d, c = f;
            break;
          }
          h = h.sibling;
        }
        if (!l) {
          for (h = f.child; h; ) {
            if (h === c) {
              l = !0, c = f, u = d;
              break;
            }
            if (h === u) {
              l = !0, u = f, c = d;
              break;
            }
            h = h.sibling;
          }
          if (!l) throw Error(t(189));
        }
      }
      if (c.alternate !== u) throw Error(t(190));
    }
    if (c.tag !== 3) throw Error(t(188));
    return c.stateNode.current === c ? s : i;
  }
  function o(s) {
    var i = s.tag;
    if (i === 5 || i === 26 || i === 27 || i === 6) return s;
    for (s = s.child; s !== null; ) {
      if (i = o(s), i !== null) return i;
      s = s.sibling;
    }
    return null;
  }
  function a(s) {
    var i = s.tag;
    if (i === 5 || i === 26 || i === 27 || i === 6) return s;
    for (s = s.child; s !== null; ) {
      if (s.tag !== 4 && (i = a(s), i !== null))
        return i;
      s = s.sibling;
    }
    return null;
  }
  return H.doesFiberContain = function(s, i) {
    for (var c = s.alternate; i !== null; ) {
      if (i === s || i === c)
        return !0;
      i = i.return;
    }
    return !1;
  }, H.findCurrentFiberUsingSlowPath = n, H.findCurrentHostFiber = function(s) {
    return s = n(s), s !== null ? o(s) : null;
  }, H.findCurrentHostFiberWithNoPortals = function(s) {
    return s = n(s), s !== null ? a(s) : null;
  }, H.getContainerFromFiber = function(s) {
    return s.tag === 3 ? s.stateNode.containerInfo : null;
  }, H.getNearestMountedFiber = e, H.getSuspenseInstanceFromFiber = function(s) {
    if (s.tag === 13) {
      var i = s.memoizedState;
      if (i === null && (s = s.alternate, s !== null && (i = s.memoizedState)), i !== null) return i.dehydrated;
    }
    return null;
  }, H.isFiberMounted = function(s) {
    return e(s) === s;
  }, H.isFiberSuspenseAndTimedOut = function(s) {
    var i = s.memoizedState;
    return s.tag === 13 && i !== null && i.dehydrated === null;
  }, H.isMounted = function(s) {
    return (s = s._reactInternals) ? e(s) === s : !1;
  }, H;
}
var eo;
function cv() {
  return eo || (eo = 1, Ge.exports = iv()), Ge.exports;
}
var uv = cv();
function lv(t) {
  return t._reactInternals;
}
function fv(t) {
  const e = lv(t);
  if (e === void 0) {
    if (typeof t.render == "function")
      throw new Error("Unable to find node on an unmounted component.");
    {
      const n = Object.keys(t).join(",");
      throw new Error(`Argument appears to not be a ReactComponent. Keys: ${n}`);
    }
  }
  const r = uv.findCurrentHostFiber(e);
  return r === null ? null : r.stateNode;
}
function dv(t) {
  return fv(t);
}
class pv {
  constructor() {
    $(this, "instanceMap", /* @__PURE__ */ new Map());
  }
  get(e) {
    return this.instanceMap.get(e);
  }
  add(e, r) {
    const n = this.instanceMap.get(e);
    n ? n.push(r) : this.instanceMap.set(e, [r]);
  }
  remove(e, r) {
    const n = this.instanceMap.get(e);
    if (r !== void 0 && Array.isArray(n)) {
      const o = n.filter((a) => a !== r);
      this.instanceMap.set(e, o);
    } else
      this.instanceMap.delete(e);
  }
  destroy() {
    this.instanceMap.clear();
  }
}
const hv = (t) => {
  const { node: e } = t, r = so(() => {
    const i = e.isContainer();
    return Ft(i) ? i : {
      placeholder: "Drag the component to place it",
      width: "100%",
      height: "100%",
      style: {}
    };
  }, [e]), { placeholder: n, height: o, width: a, style: s } = r;
  return x.createElement(
    "div",
    {
      style: {
        margin: 0,
        padding: 0,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "rgba(200,200,200,0.1)",
        border: "1px solid rgba(0,0,0,0.1)",
        borderRadius: "2px",
        fontSize: "14px",
        color: "gray",
        cursor: "default",
        minHeight: "50px",
        width: a,
        height: o,
        boxSizing: "border-box",
        ...s
      }
    },
    n
  );
};
class xv extends x.Component {
  constructor(r) {
    super(r);
    $(this, "instanceManager", new pv());
    $(this, "renderRef");
    $(this, "dropPlaceholder", hv);
    $(this, "_components", {});
    $(this, "onGetComponent", (r, n) => {
      var c, u;
      const o = this;
      let a = r;
      const s = (u = (c = n.material) == null ? void 0 : c.value.advanceCustom) == null ? void 0 : u.wrapComponent;
      s && (a = s(r, {
        node: n,
        ctx: window.__C_ENGINE_DESIGNER_PLUGIN_CTX__
      }));
      class i extends x.Component {
        constructor() {
          super(...arguments);
          $(this, "_DESIGN_BOX", !0);
          $(this, "_NODE_MODEL", n);
          $(this, "_NODE_ID", n.id);
          $(this, "_UNIQUE_ID", `${n.id}_${et()}`);
          $(this, "_STATUS");
          $(this, "_design_target_component", x.createRef());
          $(this, "_dom");
        }
        componentDidMount() {
          o.instanceManager.add(n.id, this);
        }
        getTargetComponentRef() {
          return this._design_target_component;
        }
        componentWillUnmount() {
          this._STATUS = "DESTROY", o.instanceManager.remove(n.id, this);
        }
        getDom() {
          var h, v;
          return ((v = (h = n.material) == null ? void 0 : h.value.advanceCustom) == null ? void 0 : v.autoGetDom) ?? !0 ? dv(this) : this._dom;
        }
        render() {
          var b, y, S, j;
          const { children: l = [], onlyRenderChild: h, ...v } = this.props, _ = {
            ...v,
            ref: (N) => {
              this._design_target_component.current = N;
            }
          };
          let p = l;
          if (ot(l) || (p = [l]), !!!p.filter(Boolean).length && (n.isContainer() || n.value.componentName === rt.ROOT_CONTAINER)) {
            const N = (y = (b = n.material) == null ? void 0 : b.value.advanceCustom) == null ? void 0 : y.dropPlaceholder;
            p.push(
              x.createElement(N || o.dropPlaceholder, {
                node: n
              })
            );
          }
          return h ? p : ((j = (S = n.material) == null ? void 0 : S.value.advanceCustom) == null ? void 0 : j.autoGetDom) ?? !0 ? x.createElement(a, _, ...p) : x.createElement(
            a,
            {
              ..._,
              //  注入到组件中, 配合设计器使用
              $SET_DOM: (w) => {
                this._dom = w;
              }
            },
            ...p
          );
        }
      }
      return x.forwardRef(function(f, l) {
        return x.createElement(
          av,
          {
            node: n,
            targetComponent: i
          },
          x.createElement(i, {
            ref: l,
            ...f
          })
        );
      });
    });
    this._components = Object.assign(this._components, this.props.components), this.renderRef = x.createRef(), r.dropPlaceholder && (this.dropPlaceholder = r.dropPlaceholder);
  }
  updateComponents(r = {}) {
    this._components = Object.assign(this._components, r), this.forceUpdate();
  }
  componentDidMount() {
    var r, n;
    window.__CHAMN_RENDER_MODE = "DESIGN", this.updateComponents(this.props.components), (n = (r = this.props).onMount) == null || n.call(r, this);
  }
  getPageModel() {
    var r;
    return (r = this.renderRef.current) == null ? void 0 : r.state.pageModel;
  }
  rerender(r) {
    var n;
    return (n = this.renderRef.current) == null ? void 0 : n.rerender(r);
  }
  getInstancesById(r, n) {
    let o = [...this.instanceManager.get(r) || []];
    return n !== void 0 && (o = o.filter((a) => n === (a == null ? void 0 : a._UNIQUE_ID))), o;
  }
  getInstanceByDom(r) {
    const n = xa(r);
    if (!n)
      return null;
    const o = Aa(n);
    return (o == null ? void 0 : o.stateNode) || null;
  }
  getDomsById(r, n) {
    const o = this.getInstancesById(r), a = [];
    return o == null || o.forEach((s) => {
      var c;
      if ((s == null ? void 0 : s._STATUS) === "DESTROY")
        return;
      const i = s.getDom();
      if (i && !(i instanceof Text))
        if (n) {
          const u = Array.from(((c = i.querySelectorAll) == null ? void 0 : c.call(i, n)) || []);
          a.push(...u);
        } else
          a.push(i);
    }), a;
  }
  getDomRectById(r, n) {
    return this.getDomsById(r, n).map((s) => s == null ? void 0 : s.getBoundingClientRect()).filter(Boolean);
  }
  render() {
    const { props: r, onGetComponent: n } = this, { render: o, ...a } = r;
    return o && (o.ref.current = this), x.createElement(ov, {
      onGetComponent: n,
      ...a,
      components: this._components,
      // 拦截特殊属性配置, 配合设计模式使用
      /**
       * 可以对节点的一些配置数据做统一处理
       * 比如: fixedProps 强制将 fixedProps 内的值覆盖 node 本省的配置
       * 比如： 统一处理节点的 Condition 属性，控制节点是否显示
       * @param config
       * @param node
       * @returns
       */
      processNodeConfigHook: (s, i) => {
        var v, _;
        if (i.nodeType !== "NODE")
          return s;
        const { props: c, condition: u } = s;
        let d = { ...c };
        const f = ((v = i.value.configure) == null ? void 0 : v.devState) || {}, l = (_ = i.material) == null ? void 0 : _.value.fixedProps;
        if (l !== void 0) {
          if (Ft(l))
            d = {
              ...d,
              ...l
            };
          else if (typeof l == "function") {
            const p = l(d);
            d = {
              ...d,
              ...p
            };
          }
        }
        let h = u;
        return f.condition === !1 && (h = f.condition), {
          props: Uu(d, f.props || {}),
          condition: h
        };
      },
      renderMode: "design",
      ref: this.renderRef
    });
  }
}
const xa = (t) => {
  if (!t)
    return null;
  const e = Object.keys(t).find((r) => r.startsWith("__reactInternalInstance$") || r.startsWith("__reactFiber$")) || "";
  return e ? t[e] : xa(t.parentElement);
}, Aa = (t) => {
  var e;
  return t ? (e = t == null ? void 0 : t.stateNode) != null && e._DESIGN_BOX ? t : Aa(t.return) : null;
}, Av = () => {
  const t = ao(null);
  return {
    ref: t,
    rerender: function(...e) {
      t.current && t.current.rerender(...e);
    },
    getInstancesById(e, r) {
      var n;
      return ((n = t.current) == null ? void 0 : n.getInstancesById(e, r)) || [];
    },
    getInstanceByDom(e) {
      var r;
      return ((r = t.current) == null ? void 0 : r.getInstanceByDom(e)) || null;
    },
    getDomsById(e, r) {
      var n;
      return ((n = t.current) == null ? void 0 : n.getDomsById(e, r)) || [];
    },
    getDomRectById(e, r) {
      var n;
      return ((n = t.current) == null ? void 0 : n.getDomRectById(e, r)) || [];
    }
  };
};
var pe = { exports: {} }, gv = pe.exports, ro;
function vv() {
  return ro || (ro = 1, function(t, e) {
    (function(r, n) {
      t.exports = n();
    })(gv, function() {
      var r = function() {
      }, n = {}, o = {}, a = {};
      function s(l, h) {
        l = l.push ? l : [l];
        var v = [], _ = l.length, p = _, g, m, b, y;
        for (g = function(S, j) {
          j.length && v.push(S), p--, p || h(v);
        }; _--; ) {
          if (m = l[_], b = o[m], b) {
            g(m, b);
            continue;
          }
          y = a[m] = a[m] || [], y.push(g);
        }
      }
      function i(l, h) {
        if (l) {
          var v = a[l];
          if (o[l] = h, !!v)
            for (; v.length; )
              v[0](l, h), v.splice(0, 1);
        }
      }
      function c(l, h) {
        l.call && (l = { success: l }), h.length ? (l.error || r)(h) : (l.success || r)(l);
      }
      function u(l, h, v, _) {
        var p = document, g = v.async, m = (v.numRetries || 0) + 1, b = v.before || r, y = l.replace(/[\?|#].*$/, ""), S = l.replace(/^(css|img|module|nomodule)!/, ""), j, N, w;
        if (_ = _ || 0, /(^css!|\.css$)/.test(y))
          w = p.createElement("link"), w.rel = "stylesheet", w.href = S, j = "hideFocus" in w, j && w.relList && (j = 0, w.rel = "preload", w.as = "style");
        else if (/(^img!|\.(png|gif|jpg|svg|webp)$)/.test(y))
          w = p.createElement("img"), w.src = S;
        else if (w = p.createElement("script"), w.src = S, w.async = g === void 0 ? !0 : g, N = "noModule" in w, /^module!/.test(y)) {
          if (!N) return h(l, "l");
          w.type = "module";
        } else if (/^nomodule!/.test(y) && N) return h(l, "l");
        w.onload = w.onerror = w.onbeforeload = function(V) {
          var ht = V.type[0];
          if (j)
            try {
              w.sheet.cssText.length || (ht = "e");
            } catch (gt) {
              gt.code != 18 && (ht = "e");
            }
          if (ht == "e") {
            if (_ += 1, _ < m)
              return u(l, h, v, _);
          } else if (w.rel == "preload" && w.as == "style")
            return w.rel = "stylesheet";
          h(l, ht, V.defaultPrevented);
        }, b(l, w) !== !1 && p.head.appendChild(w);
      }
      function d(l, h, v) {
        l = l.push ? l : [l];
        var _ = l.length, p = _, g = [], m, b;
        for (m = function(y, S, j) {
          if (S == "e" && g.push(y), S == "b")
            if (j) g.push(y);
            else return;
          _--, _ || h(g);
        }, b = 0; b < p; b++) u(l[b], m, v);
      }
      function f(l, h, v) {
        var _, p;
        if (h && h.trim && (_ = h), p = (_ ? v : h) || {}, _) {
          if (_ in n)
            throw "LoadJS";
          n[_] = !0;
        }
        function g(m, b) {
          d(l, function(y) {
            c(p, y), m && c({ success: m, error: b }, y), i(_, y);
          }, p);
        }
        if (p.returnPromise) return new Promise(g);
        g();
      }
      return f.ready = function(h, v) {
        return s(h, function(_) {
          c(v, _);
        }), f;
      }, f.done = function(h) {
        i(h, []);
      }, f.reset = function() {
        n = {}, o = {}, a = {};
      }, f.isDefined = function(h) {
        return h in n;
      }, f;
    });
  }(pe)), pe.exports;
}
var mv = vv();
const no = /* @__PURE__ */ sv(mv);
class Tv {
  constructor(e, r) {
    $(this, "assets");
    $(this, "loadStatus");
    $(this, "win", window);
    $(this, "_onSuccessList", []);
    $(this, "_onErrorList", []);
    this.assets = JSON.parse(JSON.stringify(e || [])), this.loadStatus = "INIT", r != null && r.window && (this.win = r.window);
  }
  load(e) {
    const r = this.assets || [], n = [];
    for (let o = 0; o < r.length; o++) {
      const a = r[o];
      a.id || (a.id = et()), n.push(a.id);
      const s = a.resources.map((i) => i.src);
      s.length && no(s, a.id, {
        async: (e == null ? void 0 : e.async) ?? !1,
        before: (i, c) => (this.win.document.body.appendChild(c), !1)
      });
    }
    return new Promise((o, a) => {
      if (r.length === 0) {
        this._onSuccessList.forEach((s) => s()), o("");
        return;
      }
      no.ready(n, {
        success: () => {
          this._onSuccessList.forEach((s) => s()), o("");
        },
        error: (s) => {
          this._onErrorList.forEach((i) => i(s)), a(s);
        }
      });
    });
  }
  onSuccess(e) {
    return this._onSuccessList.push(e), this;
  }
  onError(e) {
    return this._onErrorList.push(e), this;
  }
}
export {
  Tv as AssetLoader,
  pv as ComponentInstanceManager,
  Re as DYNAMIC_COMPONENT_TYPE,
  hv as DefaultDropPlaceholder,
  Jg as DefineReactAdapter,
  xv as DesignRender,
  Ug as INNER_EVENT_LIST,
  Vg as InnerPropList,
  Na as ON_DID_RENDER,
  ja as ON_WILL_DESTROY,
  Nv as ReactAdapter,
  Do as RefManager,
  ov as Render,
  Gu as canAcceptsRef,
  Ev as collectVariable,
  zu as compWrapper,
  se as convertCodeStringToFunction,
  Ju as findComponentByChainRefer,
  $v as flatObject,
  ku as formatSourceStylePropertyName,
  za as getAdapter,
  Ov as getCSSTextValue,
  wv as getComponentsLibs,
  bn as getInheritObj,
  Hu as getMatchVal,
  yn as getNodeCssClassName,
  Po as getObjFromArrayMap,
  Cv as getThirdLibs,
  Sv as isClass,
  At as runExpression,
  Bu as shouldConstruct,
  Av as useDesignRender,
  jv as useRender
};
//# sourceMappingURL=index.js.map
